import BalançoFiltrado from './BalancoFiltrado';
import AlbumFotos from './AlbumFotos';
import InfoAdicionais from './InfoAdicionais';
import PlanejamentoSafra from './PlanejamentoSafra';
import { getCropLifecycle } from '../utils/cropLifecycle';

// ─── Status do talhão baseado nas datas ───────────────────────────────────────
function getTalhaoStatus(talhao) {
  if (talhao?.status === 'colhido') return 'colhido';
  return { active: 'ativo', planned: 'planejado', harvested: 'colhido', available: 'disponivel' }[getCropLifecycle(talhao || {})];
}
// ...existing code...
import React, { useState, useEffect, useMemo, useContext } from 'react';
import FenologiaNova from './Fenologia';
import GraficoHistoricoApex from '../components/GraficoHistoricoApex';
import {
  FaArrowDown,
  FaArrowUp,
  FaCalendarAlt,
  FaChartLine,
  FaCheckCircle,
  FaCloudRain,
  FaDatabase,
  FaEdit,
  FaExclamationTriangle,
  FaFileExcel,
  FaFilePdf,
  FaInfoCircle,
  FaKeyboard,
  FaShieldAlt,
  FaSyncAlt,
  FaTemperatureHigh,
  FaTint,
  FaTrash,
} from 'react-icons/fa';
import { supabase } from '../supabaseClient';
import { calcularFasesFenologicas } from '../utils/fenologia';
import jsPDF from 'jspdf';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake ? pdfFonts.pdfMake.vfs : pdfFonts;
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { Capacitor } from '@capacitor/core';
import { usePlanLimits } from '../hooks/usePlanLimits';
import UpgradeModal from '../components/UpgradeModal';
import { ThemeContext } from '../App';
import { calculateClimateCoverage } from '../utils/climateCoverage';
import './propriedades-platform.css';

// Importação condicional do Capacitor Filesystem
let Filesystem, Directory;
if (typeof window !== 'undefined' && window.Capacitor) {
  try {
    // eslint-disable-next-line
    ({ Filesystem, Directory } = require('@capacitor/filesystem'));
  } catch (e) {
    // Ignora se não estiver disponível
  }
}

// Importação condicional do File Opener
let FileOpener;
if (typeof window !== 'undefined' && window.Capacitor) {
  try {
    ({ FileOpener } = require('@capacitor-community/file-opener'));
  } catch (e) {
    // Ignora se não estiver disponível
  }
}
// ...existing code...

// Removido: definição duplicada da função DentroTalhoes

// --- COMPONENTE FENOLOGIA ---
function Fenologia({ dataPlantio, dataColheita }) {
  if (!dataPlantio) {
    return <div>Data de plantio não informada.</div>;
  }

  const fases = [
    { nome: 'Emergência', dias: 0 },
    { nome: 'Crescimento Vegetativo', dias: 10 },
    { nome: 'Florescimento', dias: 40 },
    { nome: 'Enchimento de Grãos', dias: 60 },
    { nome: 'Maturação', dias: 90 }
  ];

  // Se foi colhido, usar a data de colheita; senão, usar data atual
  const dataReferencia = dataColheita ? new Date(dataColheita) : new Date();
  const diasDesdePlantio = Math.floor(
    (dataReferencia - new Date(dataPlantio)) / (1000 * 60 * 60 * 24)
  );

  let faseAtualIdx = 0;
  for (let i = 0; i < fases.length; i++) {
    if (diasDesdePlantio >= fases[i].dias) {
      faseAtualIdx = i;
    }
  }

  // Se foi colhido, considerar que chegou até a maturação
  const isColhido = !!dataColheita;
  if (isColhido && faseAtualIdx < fases.length - 1) {
    faseAtualIdx = fases.length - 1; // Força última fase (Maturação)
  }

  return (
    <div>
      <h3 style={{ color: '#1976d2', marginBottom: 12 }}>Fases Fenológicas</h3>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {fases.map((fase, idx) => (
          <div
            key={fase.nome}
            style={{
              padding: '12px 18px',
              borderRadius: 8,
              background: idx === faseAtualIdx ? '#2e9e6e' : '#f8fafc',
              color: idx === faseAtualIdx ? '#fff' : '#232526',
              fontWeight: idx === faseAtualIdx ? 700 : 500,
              border: idx === faseAtualIdx ? '2px solid #1976d2' : '1px solid #eee',
              boxShadow: idx === faseAtualIdx ? '0 2px 8px #2e9e6e33' : undefined,
              transition: 'all 0.2s'
            }}
          >
            {fase.nome}
            <span style={{ marginLeft: 12, fontWeight: 400, fontSize: 14, color: idx === faseAtualIdx ? '#fff' : '#1976d2' }}>
              (a partir de {fase.dias} dias)
            </span>
            {idx === faseAtualIdx && !isColhido && (
              <span style={{ marginLeft: 16, fontWeight: 700, color: '#ffd54f' }}>
                ← Fase Atual
              </span>
            )}
            {isColhido && idx === faseAtualIdx && (
              <span style={{ marginLeft: 16, fontWeight: 700, color: '#4caf50' }}>
                🌾 Colhido
              </span>
            )}
          </div>
        ))}
      </div>
      <div style={{ marginTop: 18, color: '#1976d2', fontWeight: 500 }}>
        {isColhido ? (
          <>
            Ciclo completo: <b>{diasDesdePlantio} dias</b> • Colhido em {new Date(dataColheita).toLocaleDateString('pt-BR')}
          </>
        ) : (
          <>
            Dias desde o plantio: <b>{diasDesdePlantio}</b>
          </>
        )}
      </div>
    </div>
  );
}

// Helper: retorna 'YYYY-MM-DD' no fuso local (evita UTC shift do toISOString em UTC-3)
const localDateStr = (d = new Date()) => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${dd}`;
};

// --- COMPONENTE BALANÇO HÍDRICO ---
function BalancoHidrico({ talhao, permission = 'owner' }) {
  // Filtros para histórico
  const [filtroPeriodo, setFiltroPeriodo] = useState(30);
  const [dataInicioFiltro, setDataInicioFiltro] = useState(talhao?.data_plantio ? talhao.data_plantio.slice(0,10) : '');
  const [dataFimFiltro, setDataFimFiltro] = useState(localDateStr());
  const [faseSelecionada, setFaseSelecionada] = useState('');
  // Estado do histórico de balanço hídrico
  
  // Permissão: owner e editor podem atualizar dados meteorológicos
  const podeAtualizar = permission === 'owner' || permission === 'editor';

  // Ajustes de fenologia feitos pelo usuário na modal Fenologia
  const [datasAjustadas, setDatasAjustadas] = useState({});

  useEffect(() => {
    if (!talhao?.id) return;
    (async () => {
      try {
        const { data } = await supabase
          .from('fenologia_ajustada')
          .select('*')
          .eq('talhao_id', talhao.id);
        if (data && Array.isArray(data)) {
          const ajustadas = {};
          data.forEach(row => {
            ajustadas[row.fase_idx] = { inicioFase: row.inicio, fimFase: row.fim };
          });
          setDatasAjustadas(ajustadas);
        }
      } catch (e) {
        console.error('[BalancoHidrico] Erro ao carregar ajustes fenologia:', e);
      }
    })();
  }, [talhao?.id]);

  // Fases fenológicas dinâmicas baseadas na cultura e nos ajustes do usuário
  const fases = useMemo(() => {
    if (!talhao?.data_plantio || !talhao?.cultura) return {};
    const fasesArray = calcularFasesFenologicas(talhao.cultura, talhao.data_plantio, datasAjustadas);
    if (!fasesArray.length) return {};
    const obj = {};
    fasesArray.forEach(f => {
      obj[f.nome] = { ini: f.inicio, fim: f.fim };
    });
    return obj;
  }, [talhao?.data_plantio, talhao?.cultura, datasAjustadas]);

  // Histórico filtrado
  const [dadosClima, setDadosClima] = useState(null);
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState(null);
  const [dadosDoCache, setDadosDoCache] = useState(false);
  const [dadosDiarios, setDadosDiarios] = useState([]);
  const [mostrarGraficos, setMostrarGraficos] = useState(false);
  const [loadingGraficos, setLoadingGraficos] = useState(false);
  const [climatologia, setClimatologia] = useState(null);
  const [loadingClimatologia, setLoadingClimatologia] = useState(false);

  // Carregar dados do cache automaticamente quando o componente for montado
  useEffect(() => {
    const carregarDadosDoCache = async () => {
      setDadosClima(null);
      setErro(null);
      setDadosDoCache(false);
      if (!talhao?.coordenada_x || !talhao?.coordenada_y || !talhao?.id) {
        return;
      }

      try {
        console.log('🔄 Carregando dados do cache automaticamente...', { talhaoId: talhao.id });
        
        const lat = parseFloat(talhao.coordenada_y);
        const lon = parseFloat(talhao.coordenada_x);
        
        // Definir período de análise (mesmo lógica da busca manual)
        const dataFim = talhao.data_colheita ? new Date(talhao.data_colheita) : new Date();
        const dataInicio = talhao.data_plantio ? new Date(talhao.data_plantio) : new Date();
        
        if (!talhao.data_plantio) {
          dataInicio.setDate(dataInicio.getDate() - 30);
        }

        // Limitar período máximo a 7 anos (2555 dias)
        const diasDiferenca = Math.floor((dataFim - dataInicio) / (1000 * 60 * 60 * 24));
        if (diasDiferenca > 2555) {
          const dataInicioLimitada = new Date(dataFim);
          dataInicioLimitada.setDate(dataInicioLimitada.getDate() - 2555);
          dataInicio.setTime(dataInicioLimitada.getTime());
        }

        const dataInicioStr = talhao.data_plantio && diasDiferenca <= 2555
          ? talhao.data_plantio.slice(0, 10)
          : localDateStr(dataInicio);
        const dataFimStr = talhao.data_colheita ? talhao.data_colheita.slice(0, 10) : localDateStr(dataFim);

        const { DadosMeteorologicosService } = await import('../services/DadosMeteorologicosService');
        
        // Primeiro, tentar buscar apenas do cache (sem chamar NASA Power)
        const dadosCache = await DadosMeteorologicosService.buscarDadosCache(talhao.id, dataInicioStr, dataFimStr);
        
        if (dadosCache && dadosCache.length > 0) {
          console.log('✅ Dados encontrados no cache:', dadosCache.length, 'registros');
          
          // Converter dados para formato compatível
          const dadosCompatíveis = {
            properties: {
              parameter: convertToNASAFormat(dadosCache)
            }
          };
          
          setDadosClima(dadosCompatíveis);
          setDadosDoCache(true);
        } else {
          console.log('ℹ️ Nenhum dado encontrado no cache para este período');
          setDadosDoCache(false);
        }
      } catch (error) {
        console.error('❌ Erro ao carregar dados do cache:', error);
      }
    };

    carregarDadosDoCache();
  }, [talhao?.id, talhao?.coordenada_x, talhao?.coordenada_y, talhao?.data_plantio, talhao?.data_colheita]);

  // Buscar climatologia histórica NASA POWER (média 1991–2020)
  useEffect(() => {
    if (!talhao?.coordenada_x || !talhao?.coordenada_y) return;
    const lat = parseFloat(talhao.coordenada_y);
    const lon = parseFloat(talhao.coordenada_x);
    if (isNaN(lat) || isNaN(lon)) return;
    let ativo = true;
    setLoadingClimatologia(true);
    import('../services/DadosMeteorologicosService')
      .then(({ DadosMeteorologicosService }) => DadosMeteorologicosService.buscarClimatologia(lon, lat))
      .then(parametros => {
        if (ativo) setClimatologia(parametros ?? null);
      })
      .catch(error => {
        console.warn('Não foi possível carregar a normal histórica do talhão.', error);
        if (ativo) setClimatologia(null);
      })
      .finally(() => {
        if (ativo) setLoadingClimatologia(false);
      });
    return () => { ativo = false; };
  }, [talhao?.coordenada_x, talhao?.coordenada_y]);

  // Função para buscar dados meteorológicos (cache + NASA POWER)
  const buscarDadosNASA = async () => {
    if (!talhao.coordenada_x || !talhao.coordenada_y) {
      setErro('Coordenadas do talhão não informadas');
      return;
    }

    // Validar coordenadas (valores aproximados para o Brasil)
    const lat = parseFloat(talhao.coordenada_y);
    const lon = parseFloat(talhao.coordenada_x);
    
    if (lat < -35 || lat > 5 || lon < -75 || lon > -30) {
      setErro(`Coordenadas parecem inválidas para o Brasil. Latitude: ${lat}, Longitude: ${lon}`);
      return;
    }

    setLoading(true);
    setErro(null);

    try {
      console.log('🌍 Buscando dados meteorológicos (cache + NASA POWER)...', { talhaoId: talhao.id, lat, lon });

      // Data atual (ou data de colheita se existir) e data de plantio como início
      const dataFim = talhao.data_colheita ? new Date(talhao.data_colheita) : new Date();
      const dataInicio = talhao.data_plantio ? new Date(talhao.data_plantio) : new Date();
      
      // Se não há data de plantio, usar últimos 30 dias
      if (!talhao.data_plantio) {
        dataInicio.setDate(dataInicio.getDate() - 30);
      }

      // Calcular diferença de dias para exibir no log
      const diasDiferenca = Math.floor((dataFim - dataInicio) / (1000 * 60 * 60 * 24));

      // Limitar período máximo a 365 dias (limitação da API NASA)
      // Removido limite de 365 dias para permitir análise de todo o período selecionado

      const dataInicioStr = talhao.data_plantio ? talhao.data_plantio.slice(0, 10) : localDateStr(dataInicio);
      const dataFimStr = talhao.data_colheita ? talhao.data_colheita.slice(0, 10) : localDateStr(dataFim);

      console.log('📅 Período de análise:', {
        dataPlantio: talhao.data_plantio,
        dataInicio: dataInicioStr,
        dataFim: dataFimStr,
        diasAnalisados: diasDiferenca > 365 ? 365 : diasDiferenca
      });

      // Usar o novo serviço que gerencia cache + API
      const { DadosMeteorologicosService } = await import('../services/DadosMeteorologicosService');
      const dadosProcessados = await DadosMeteorologicosService.obterDadosMeteorologicos(
        talhao.id,
        lon,
        lat,
        dataInicioStr,
        dataFimStr
      );

      if (!dadosProcessados.length) {
        throw new Error('Nenhum dia meteorológico válido foi encontrado para o período selecionado.');
      }

      // Converter dados para formato compatível com o componente existente
      const dadosCompatíveis = {
        properties: {
          parameter: convertToNASAFormat(dadosProcessados)
        }
      };
      
      console.log('✅ Dados meteorológicos obtidos:', dadosProcessados.length, 'registros');
      setDadosClima(dadosCompatíveis);
      setDadosDoCache(false); // Dados vieram da API, não do cache

      await salvarBalancoCalculado(lon, lat, dadosCompatíveis);

    } catch (error) {
      console.error('Erro ao buscar dados NASA POWER:', error);
      setErro(`Erro ao buscar dados: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  // Função para salvar o balanço hídrico calculado no Supabase
  const salvarBalancoCalculado = async (lon, lat, dadosFonte = dadosClima) => {
    try {
      const balancoCalculado = calcularBalanco(dadosFonte);
      if (!balancoCalculado) {
        console.warn('⚠️ Balanço não pôde ser calculado para salvar');
        return;
      }

      console.log('💾 Salvando balanço hídrico calculado...', balancoCalculado);
      
      const { DadosMeteorologicosService } = await import('../services/DadosMeteorologicosService');
      await DadosMeteorologicosService.salvarBalancoHidrico(
        talhao.id,
        lon,
        lat,
        balancoCalculado
      );
      
      console.log('✅ Balanço hídrico salvo com sucesso!');
    } catch (error) {
      console.error('❌ Erro ao salvar balanço hídrico:', error);
      // Não mostramos o erro para o usuário, apenas logamos
    }
  };

  // Função para buscar dados diários para gráficos do ciclo da cultura
  const buscarDadosGraficos = async () => {
    setLoadingGraficos(true);
    try {
      console.log('📈 Buscando dados diários para gráficos do ciclo...', { 
        talhaoId: talhao.id,
        dataPlantio: talhao.data_plantio,
        dataColheita: talhao.data_colheita
      });
      
      const { DadosMeteorologicosService } = await import('../services/DadosMeteorologicosService');
      const dados = await DadosMeteorologicosService.buscarDadosDiariosParaGraficos(
        talhao.id, 
        talhao.data_plantio, 
        talhao.data_colheita
      );
      
      console.log('✅ Dados diários obtidos:', dados);
      setDadosDiarios(dados || []);
      setMostrarGraficos(true);
    } catch (error) {
      console.error('❌ Erro ao buscar dados para gráficos:', error);
      setErro(`Erro ao buscar dados para gráficos: ${error.message}`);
    } finally {
      setLoadingGraficos(false);
    }
  };

  // Função para converter dados do serviço para formato NASA POWER
  const convertToNASAFormat = (dadosProcessados) => {
    const parameter = {
      PRECTOTCORR: {},
      T2M_MAX: {},
      T2M_MIN: {},
      RH2M: {},
      WS2M: {},
      ALLSKY_SFC_SW_DWN: {}
    };

    dadosProcessados.forEach(dado => {
      const dataFormatada = dado.data.replace(/-/g, '');
      parameter.PRECTOTCORR[dataFormatada] = dado.precipitacao;
      parameter.T2M_MAX[dataFormatada] = dado.temp_max;
      parameter.T2M_MIN[dataFormatada] = dado.temp_min;
      parameter.RH2M[dataFormatada] = dado.umidade;
      parameter.WS2M[dataFormatada] = dado.vento;
      parameter.ALLSKY_SFC_SW_DWN[dataFormatada] = dado.radiacao;
    });

    return parameter;
  };

  // Função para validar se o valor é válido (não é código de erro da NASA)
  const isValidValue = (value) => {
    return value !== undefined && 
           value !== null && 
           value !== -999 && 
           value !== -99 && 
           value > -900 && // Valores muito negativos são códigos de erro
           !isNaN(value);
  };

  // Função para calcular balanço hídrico com validação robusta
  const calcularBalanco = (dadosFonte = dadosClima) => {
    if (!dadosFonte || !dadosFonte.properties || !dadosFonte.properties.parameter) {
      return null;
    }

    const params = dadosFonte.properties.parameter;
    const precipitacao = params.PRECTOTCORR || {};
    const tempMax = params.T2M_MAX || {};
    const tempMin = params.T2M_MIN || {};
    const umidade = params.RH2M || {};

    console.log('Dados brutos NASA POWER:', params); // Debug

    const datas = Object.keys(precipitacao);
    let totalPrecipitacao = 0;
    let somaTemp = 0;
    let somaUmidade = 0;
    let diasValidos = 0;
    let precipitacaoValidos = 0;
    let tempValidos = 0;
    let umidadeValidos = 0;

    datas.forEach(data => {
      const prec = precipitacao[data];
      const tMax = tempMax[data];
      const tMin = tempMin[data];
      const um = umidade[data];

      // Validar precipitação (não pode ser negativa)
      if (isValidValue(prec) && prec >= 0) {
        totalPrecipitacao += prec;
        precipitacaoValidos++;
      }

      // Validar temperaturas (valores razoáveis: -50°C a 60°C)
      if (isValidValue(tMax) && isValidValue(tMin) && 
          tMax >= -50 && tMax <= 60 && 
          tMin >= -50 && tMin <= 60) {
        somaTemp += (tMax + tMin) / 2;
        tempValidos++;
      }

      // Validar umidade (0-100%)
      if (isValidValue(um) && um >= 0 && um <= 100) {
        somaUmidade += um;
        umidadeValidos++;
      }

      // Contar dias com pelo menos alguns dados válidos
      if ((isValidValue(prec) && prec >= 0) || 
          (isValidValue(tMax) && tMax >= -50 && tMax <= 60) || 
          (isValidValue(tMin) && tMin >= -50 && tMin <= 60)) {
        diasValidos++;
      }
    });

    console.log('Validação dos dados:', {
      totalDias: datas.length,
      diasValidos,
      precipitacaoValidos,
      tempValidos,
      umidadeValidos
    });

    if (diasValidos === 0 || precipitacaoValidos === 0 || tempValidos === 0) {
      return null;
    }

    const mediaTemp = somaTemp / tempValidos;
    const mediaUmidade = umidadeValidos > 0 ? somaUmidade / umidadeValidos : 50; // Default 50% se não há dados

    // Método Penman-Monteith FAO-56 para cálculo da ETo
    const calcularPenmanMonteith = () => {
      const radiacao = params.ALLSKY_SFC_SW_DWN || {};
      const vento = params.WS2M || {};
      
      let somaETo = 0;
      let diasComETo = 0;
      
      datas.forEach(data => {
        const tMax = tempMax[data];
        const tMin = tempMin[data];
        const um = umidade[data];
        const rad = radiacao[data]; // MJ/m²/dia
        const wind = vento[data]; // m/s
        
        if (isValidValue(tMax) && isValidValue(tMin) && 
            tMax >= -50 && tMax <= 60 && tMin >= -50 && tMin <= 60) {
          
          const tmean = (tMax + tMin) / 2;
          const deltaT = tMax - tMin;
          const u2 = isValidValue(wind) && wind >= 0 ? wind : 2.0; // Default 2 m/s
          const rh = isValidValue(um) && um >= 0 && um <= 100 ? um : 50; // Default 50%
          const Rs = isValidValue(rad) && rad >= 0 ? rad : null;
          
          // Constantes
          const gamma = 0.665; // Constante psicrométrica (kPa/°C)
          
          // Pressão de vapor de saturação (kPa)
          const es_tmax = 0.6108 * Math.exp(17.27 * tMax / (tMax + 237.3));
          const es_tmin = 0.6108 * Math.exp(17.27 * tMin / (tMin + 237.3));
          const es = (es_tmax + es_tmin) / 2;
          
          // Pressão de vapor atual (kPa)
          const ea = es * (rh / 100);
          
          // Inclinação da curva de pressão de vapor (kPa/°C)
          const delta = 4098 * es / Math.pow(tmean + 237.3, 2);
          
          // Radiação extraterrestre estimada (Ra) - valor médio para Brasil
          const Ra_estimado = 15.0; // MJ/m²/dia
          
          // Radiação solar (Rs) - estimativa se não disponível
          let radiacao_solar = Rs;
          if (!radiacao_solar) {
            // Estimativa básica baseada na amplitude térmica
            radiacao_solar = Ra_estimado * 0.16 * Math.sqrt(deltaT);
          }
          
          // Saldo de radiação (Rn) - simplificado
          const albedo = 0.23; // Albedo da grama de referência
          const Rns = (1 - albedo) * radiacao_solar; // Radiação solar líquida
          const stefan_boltzmann = 4.903e-9;
          const Rnl = stefan_boltzmann * (Math.pow(tMax + 273.16, 4) + Math.pow(tMin + 273.16, 4)) / 2 * 
                     (0.34 - 0.14 * Math.sqrt(ea)) * (1.35 * Math.min(radiacao_solar / Ra_estimado, 1) - 0.35);
          const Rn = Math.max(0, Rns - Rnl);
          
          // Fluxo de calor no solo (G) - considerado zero para cálculo diário
          const G = 0;
          
          // Fórmula de Penman-Monteith FAO-56 (mm/dia)
          const numerador = 0.408 * delta * (Rn - G) + gamma * 900 / (tmean + 273) * u2 * (es - ea);
          const denominador = delta + gamma * (1 + 0.34 * u2);
          
          const ETo = Math.max(0, numerador / denominador);
          
          if (ETo > 0 && ETo < 20) { // Validação de ETo razoável (0-20 mm/dia)
            somaETo += ETo;
            diasComETo++;
          }
        }
      });
      
      return diasComETo > 0 ? somaETo / diasComETo : 0; // ETo média diária
    };
    
    const etoMedia = calcularPenmanMonteith();
    const totalETP = etoMedia * diasValidos;

    // Calcular dias desde plantio se houver data
    let diasDesdeePlantio = null;
    if (talhao.data_plantio) {
      diasDesdeePlantio = Math.floor((new Date() - new Date(talhao.data_plantio)) / (1000 * 60 * 60 * 24));
    }

    return {
      totalPrecipitacao: totalPrecipitacao.toFixed(1),
      totalETP: totalETP.toFixed(1),
      balanco: (totalPrecipitacao - totalETP).toFixed(1),
      mediaTemp: mediaTemp.toFixed(1),
      mediaUmidade: mediaUmidade.toFixed(1),
      diasAnalisados: diasValidos,
      diasDesdeePlantio: diasDesdeePlantio,
      dataPlantio: talhao.data_plantio,
      dadosValidos: {
        precipitacao: precipitacaoValidos,
        temperatura: tempValidos,
        umidade: umidadeValidos
      }
    };
  };

  // Função para filtrar dados meteorológicos conforme período/fase
  const calcularBalancoFiltrado = () => {
    if (!dadosClima || !dadosClima.properties || !dadosClima.properties.parameter) return null;
    const params = dadosClima.properties.parameter;
    const precipitacao = params.PRECTOTCORR || {};
    const tempMax = params.T2M_MAX || {};
    const tempMin = params.T2M_MIN || {};
    const umidade = params.RH2M || {};
    const radiacao = params.ALLSKY_SFC_SW_DWN || {};
    const vento = params.WS2M || {};

    // Determinar intervalo de datas
    let ini, fim;
    if (faseSelecionada && fases[faseSelecionada]) {
      ini = fases[faseSelecionada].ini;
      fim = fases[faseSelecionada].fim;
    } else if (dataInicioFiltro && dataFimFiltro) {
      ini = new Date(dataInicioFiltro);
      fim = new Date(dataFimFiltro);
    } else {
      ini = null;
      fim = null;
    }

    // Filtrar datas
    const datas = Object.keys(precipitacao).filter(dataStr => {
      const dataObj = new Date(
        dataStr.length === 8
          ? `${dataStr.slice(0,4)}-${dataStr.slice(4,6)}-${dataStr.slice(6,8)}`
          : dataStr
      );
      if (!ini || !fim) return true;
      return dataObj >= ini && dataObj <= fim;
    });

    let totalPrecipitacao = 0;
    let somaTemp = 0;
    let somaUmidade = 0;
    let diasValidos = 0;
    let precipitacaoValidos = 0;
    let tempValidos = 0;
    let umidadeValidos = 0;

    datas.forEach(data => {
      const prec = precipitacao[data];
      const tMax = tempMax[data];
      const tMin = tempMin[data];
      const um = umidade[data];

      if (isValidValue(prec) && prec >= 0) {
        totalPrecipitacao += prec;
        precipitacaoValidos++;
      }
      if (isValidValue(tMax) && isValidValue(tMin) && tMax >= -50 && tMax <= 60 && tMin >= -50 && tMin <= 60) {
        somaTemp += (tMax + tMin) / 2;
        tempValidos++;
      }
      if (isValidValue(um) && um >= 0 && um <= 100) {
        somaUmidade += um;
        umidadeValidos++;
      }
      if ((isValidValue(prec) && prec >= 0) || (isValidValue(tMax) && tMax >= -50 && tMax <= 60) || (isValidValue(tMin) && tMin >= -50 && tMin <= 60)) {
        diasValidos++;
      }
    });

    if (diasValidos === 0 || precipitacaoValidos === 0 || tempValidos === 0) return null;
    const mediaTemp = somaTemp / tempValidos;
    const mediaUmidade = umidadeValidos > 0 ? somaUmidade / umidadeValidos : 50;

    // Cálculo ETo filtrado
    let somaETo = 0;
    let diasComETo = 0;
    datas.forEach(data => {
      const tMax = tempMax[data];
      const tMin = tempMin[data];
      const um = umidade[data];
      const rad = radiacao[data];
      const wind = vento[data];
      if (isValidValue(tMax) && isValidValue(tMin) && tMax >= -50 && tMax <= 60 && tMin >= -50 && tMin <= 60) {
        const tmean = (tMax + tMin) / 2;
        const deltaT = tMax - tMin;
        const u2 = isValidValue(wind) && wind >= 0 ? wind : 2.0;
        const rh = isValidValue(um) && um >= 0 && um <= 100 ? um : 50;
        const Rs = isValidValue(rad) && rad >= 0 ? rad : null;
        const gamma = 0.665;
        const es_tmax = 0.6108 * Math.exp(17.27 * tMax / (tMax + 237.3));
        const es_tmin = 0.6108 * Math.exp(17.27 * tMin / (tMin + 237.3));
        const es = (es_tmax + es_tmin) / 2;
        const ea = es * (rh / 100);
        const delta = 4098 * es / Math.pow(tmean + 237.3, 2);
        const Ra_estimado = 15.0;
        let radiacao_solar = Rs;
        if (!radiacao_solar) {
          radiacao_solar = Ra_estimado * 0.16 * Math.sqrt(deltaT);
        }
        const albedo = 0.23;
        const Rns = (1 - albedo) * radiacao_solar;
        const stefan_boltzmann = 4.903e-9;
        const Rnl = stefan_boltzmann * (Math.pow(tMax + 273.16, 4) + Math.pow(tMin + 273.16, 4)) / 2 * (0.34 - 0.14 * Math.sqrt(ea)) * (1.35 * Math.min(radiacao_solar / Ra_estimado, 1) - 0.35);
        const Rn = Math.max(0, Rns - Rnl);
        const G = 0;
        const numerador = 0.408 * delta * (Rn - G) + gamma * 900 / (tmean + 273) * u2 * (es - ea);
        const denominador = delta + gamma * (1 + 0.34 * u2);
        const ETo = Math.max(0, numerador / denominador);
        if (ETo > 0 && ETo < 20) {
          somaETo += ETo;
          diasComETo++;
        }
      }
    });
    const etoMedia = diasComETo > 0 ? somaETo / diasComETo : 0;
    const totalETP = etoMedia * diasValidos;
    return {
      totalPrecipitacao: totalPrecipitacao.toFixed(1),
      totalETP: totalETP.toFixed(1),
      balanco: (totalPrecipitacao - totalETP).toFixed(1),
      mediaTemp: mediaTemp.toFixed(1),
      mediaUmidade: mediaUmidade.toFixed(1),
      diasAnalisados: diasValidos,
      dadosValidos: {
        precipitacao: precipitacaoValidos,
        temperatura: tempValidos,
        umidade: umidadeValidos
      }
    };
  };

  // Ajuste do valor padrão do filtro de datas
  useEffect(() => {
    if (talhao.data_plantio) {
      setDataInicioFiltro(talhao.data_plantio.slice(0,10));
    }
    if (talhao.data_colheita) {
      setDataFimFiltro(talhao.data_colheita.slice(0,10));
    } else {
      setDataFimFiltro(localDateStr());
    }
  }, [talhao.data_plantio, talhao.data_colheita]);

  const balanco = calcularBalancoFiltrado();

  const diagnosticoHidrico = (() => {
    if (!balanco || !dadosClima?.properties?.parameter) return null;

    const params = dadosClima.properties.parameter;
    const precipitacao = params.PRECTOTCORR || {};
    const tempMax = params.T2M_MAX || {};
    const tempMin = params.T2M_MIN || {};

    const normalizarData = (dataStr) => {
      const valor = String(dataStr);
      const iso = valor.length === 8
        ? `${valor.slice(0, 4)}-${valor.slice(4, 6)}-${valor.slice(6, 8)}`
        : valor.slice(0, 10);
      const [ano, mes, dia] = iso.split('-').map(Number);
      return { iso, date: new Date(ano, mes - 1, dia) };
    };

    let inicio;
    let fim;
    if (faseSelecionada && fases[faseSelecionada]) {
      inicio = new Date(fases[faseSelecionada].ini);
      fim = new Date(fases[faseSelecionada].fim);
    } else {
      inicio = dataInicioFiltro ? new Date(`${dataInicioFiltro}T00:00:00`) : null;
      fim = dataFimFiltro ? new Date(`${dataFimFiltro}T23:59:59`) : null;
    }

    const registros = Object.keys(precipitacao)
      .map((chave) => ({ chave, ...normalizarData(chave) }))
      .filter(({ date }) => (!inicio || date >= inicio) && (!fim || date <= fim))
      .sort((a, b) => a.date - b.date);

    let diasComChuva = 0;
    let sequenciaSemChuva = 0;
    let maiorSequenciaSemChuva = 0;
    let maiorChuva = null;
    const temperaturasMaximas = [];
    const temperaturasMinimas = [];

    registros.forEach(({ chave, iso }) => {
      const chuva = Number(precipitacao[chave]);
      if (isValidValue(chuva) && chuva >= 0) {
        if (chuva > 0) {
          diasComChuva += 1;
          sequenciaSemChuva = 0;
          if (!maiorChuva || chuva > maiorChuva.valor) maiorChuva = { valor: chuva, data: iso };
        } else {
          sequenciaSemChuva += 1;
          maiorSequenciaSemChuva = Math.max(maiorSequenciaSemChuva, sequenciaSemChuva);
        }
      }

      const maxima = Number(tempMax[chave]);
      const minima = Number(tempMin[chave]);
      if (isValidValue(maxima) && maxima >= -50 && maxima <= 60) temperaturasMaximas.push(maxima);
      if (isValidValue(minima) && minima >= -50 && minima <= 60) temperaturasMinimas.push(minima);
    });

    const precipitacaoTotal = Number(balanco.totalPrecipitacao) || 0;
    const etoTotal = Number(balanco.totalETP) || 0;
    const saldo = Number(balanco.balanco) || 0;
    const dias = Number(balanco.diasAnalisados) || 0;
    const coberturaDemanda = etoTotal > 0 ? (precipitacaoTotal / etoTotal) * 100 : null;
    const diasValidos = Math.min(
      balanco.dadosValidos.precipitacao,
      balanco.dadosValidos.temperatura,
      balanco.dadosValidos.umidade
    );
    const coberturaPeriodo = calculateClimateCoverage({
      startDate: inicio,
      endDate: fim,
      validDays: diasValidos,
    });
    const coberturaDados = coberturaPeriodo.percentage;

    const formatarData = (iso) => {
      if (!iso) return '—';
      const [ano, mes, dia] = iso.split('-').map(Number);
      return new Date(ano, mes - 1, dia).toLocaleDateString('pt-BR');
    };

    const dataInicialReal = registros[0]?.iso;
    const dataFinalReal = registros[registros.length - 1]?.iso;

    return {
      saldo,
      deficit: saldo < 0,
      coberturaDemanda,
      coberturaVisual: coberturaDemanda == null ? 0 : Math.min(100, Math.max(0, coberturaDemanda)),
      coberturaDados: Math.min(100, Math.max(0, coberturaDados)),
      diasEsperados: coberturaPeriodo.expectedDays,
      diasAusentes: coberturaPeriodo.missingDays,
      precipitacaoMediaDia: dias > 0 ? precipitacaoTotal / dias : 0,
      etoMediaDia: dias > 0 ? etoTotal / dias : 0,
      saldoMedioDia: dias > 0 ? saldo / dias : 0,
      diasComChuva,
      maiorSequenciaSemChuva,
      maiorChuva,
      maiorChuvaData: formatarData(maiorChuva?.data),
      temperaturaMaxima: temperaturasMaximas.length ? Math.max(...temperaturasMaximas) : null,
      temperaturaMinima: temperaturasMinimas.length ? Math.min(...temperaturasMinimas) : null,
      periodoReal: dataInicialReal && dataFinalReal
        ? `${formatarData(dataInicialReal)} a ${formatarData(dataFinalReal)}`
        : 'Período sem registros válidos',
      periodoNome: faseSelecionada || 'Ciclo completo',
    };
  })();

  return (
    <div className="water-balance-dashboard" style={{ fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif' }}>
      <div className="water-balance-header" style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16, flexWrap: 'wrap' }}>
        <div className="water-balance-heading">
          <span className="water-balance-eyebrow"><FaCloudRain /> Monitoramento agrometeorológico</span>
          <h3 style={{ color: '#1976d2', margin: 0 }}>Clima do Talhão</h3>
          <p>Chuva, demanda atmosférica, saldo hídrico e qualidade dos dados deste talhão.</p>
        </div>
        <div className="water-balance-actions">
        {podeAtualizar && (
          <button
            className="water-balance-action is-primary"
            onClick={buscarDadosNASA}
            disabled={loading}
            style={{
              background: '#2e9e6e',
              color: '#fff',
              border: 'none',
              borderRadius: 6,
              padding: '6px 12px',
              fontWeight: 600,
              cursor: loading ? 'not-allowed' : 'pointer',
              fontSize: 12
            }}
          >
            <FaSyncAlt className={loading ? 'is-spinning' : ''} />
            {loading ? 'Carregando...' : dadosClima ? 'Atualizar dados' : 'Buscar dados'}
          </button>
        )}
        
        <button
          className="water-balance-action is-secondary"
          onClick={() => mostrarGraficos ? setMostrarGraficos(false) : buscarDadosGraficos()}
          disabled={loadingGraficos}
          style={{
            background: '#9c27b0',
            color: '#fff',
            border: 'none',
            borderRadius: 6,
            padding: '6px 12px',
            fontWeight: 600,
            cursor: loadingGraficos ? 'not-allowed' : 'pointer',
            fontSize: 12
          }}
        >
          <FaChartLine />
          {loadingGraficos ? 'Carregando...' : mostrarGraficos ? 'Ocultar evolução' : 'Ver evolução'}
        </button>
        </div>
      </div>

      {erro && (
        <div className="water-balance-error" style={{
          background: '#ffebee',
          color: '#c62828',
          padding: 12,
          borderRadius: 8,
          marginBottom: 12,
          border: '1px solid #ffcdd2'
        }}>
          ❌ {erro}
        </div>
      )}


      {!dadosClima && !loading && (
        <div className="water-balance-empty" style={{
          background: permission === 'viewer' ? '#fff3e0' : '#e3f2fd',
          color: permission === 'viewer' ? '#e65100' : '#1565c0',
          padding: 16,
          borderRadius: 8,
          textAlign: 'center'
        }}>
          {permission === 'viewer' ? (
            <>👁️ Modo visualização: Sem dados disponíveis. Apenas o proprietário pode buscar dados meteorológicos.</>
          ) : (
            <>📊 {dadosClima ? 'Dados carregados do cache' : 'Clique em "Buscar Dados NASA" para obter informações meteorológicas'}{' '}
            {talhao.data_plantio 
              ? `desde o plantio (${new Date(talhao.data_plantio + 'T12:00:00').toLocaleDateString('pt-BR')})`
              : 'dos últimos 30 dias'
            }</>
          )}
        </div>
      )}

      {dadosClima && !loading && (
        <div className={`water-balance-source ${dadosDoCache ? 'is-cache' : 'is-updated'}`} style={{
          background: dadosDoCache ? '#e3f2fd' : '#e8f5e9',
          color: dadosDoCache ? '#1565c0' : '#2e7d32',
          padding: 12,
          borderRadius: 8,
          textAlign: 'center',
          marginBottom: 16,
          fontSize: 13,
          border: dadosDoCache ? '1px solid #2196f3' : '1px solid #4caf50'
        }}>
          {dadosDoCache ? <FaDatabase /> : <FaCheckCircle />}
          <span>{dadosDoCache
            ? 'Dados carregados do cache. Atualize para consultar informações mais recentes.'
            : 'Dados atualizados da NASA POWER e salvos automaticamente no cache.'
          }</span>
        </div>
      )}
      <div className="water-balance-filters" style={{
  display: 'flex',
  gap: 16,
  marginBottom: 16,
  flexWrap: 'wrap',
  alignItems: 'center'
}}>
  <label style={{ fontWeight: 600 }}>
    Visualizar por:
    <select
      value={faseSelecionada ? faseSelecionada : (dataInicioFiltro === (talhao.data_plantio ? talhao.data_plantio.slice(0,10) : '') && dataFimFiltro === (talhao.data_colheita ? talhao.data_colheita.slice(0,10) : localDateStr()) ? 'ciclo' : 'periodo')}
      onChange={e => {
        const value = e.target.value;
        if (value === 'ciclo') {
          setFaseSelecionada('');
          setDataInicioFiltro(talhao.data_plantio ? talhao.data_plantio.slice(0,10) : '');
          setDataFimFiltro(talhao.data_colheita ? talhao.data_colheita.slice(0,10) : localDateStr());
        } else if (value === 'periodo') {
          setFaseSelecionada('');
          // Ao selecionar período personalizado, mantém datas atuais e exibe inputs
        } else {
          setFaseSelecionada(value);
        }
      }}
      style={{ marginLeft: 8, padding: 4, borderRadius: 4 }}
    >
      <option value="ciclo">Ciclo Completo</option>
      <option value="periodo">Período Personalizado</option>
      {Object.keys(fases).map(fase => (
        <option key={fase} value={fase}>{fase}</option>
      ))}
    </select>
  </label>
  {(!faseSelecionada && (
    <>
      <label style={{ fontWeight: 600 }}>
        Início:
        <input
          type="date"
          value={dataInicioFiltro}
          min={talhao.data_plantio ? talhao.data_plantio.slice(0,10) : ''}
          max={talhao.data_colheita ? talhao.data_colheita.slice(0,10) : localDateStr()}
          onChange={e => setDataInicioFiltro(e.target.value)}
          style={{ marginLeft: 8, padding: 4, borderRadius: 4 }}
        />
      </label>
      <label style={{ fontWeight: 600 }}>
        Fim:
        <input
          type="date"
          value={dataFimFiltro}
          min={talhao.data_plantio ? talhao.data_plantio.slice(0,10) : ''}
          max={talhao.data_colheita ? talhao.data_colheita.slice(0,10) : localDateStr()}
          onChange={e => setDataFimFiltro(e.target.value)}
          style={{ marginLeft: 8, padding: 4, borderRadius: 4 }}
        />
      </label>
    </>
  ))}
</div>

      {balanco && diagnosticoHidrico && (
        <>
          <section className={`water-balance-diagnosis ${diagnosticoHidrico.deficit ? 'is-deficit' : 'is-surplus'}`}>
            <div className="water-diagnosis-copy">
              <span className="water-diagnosis-icon">
                {diagnosticoHidrico.deficit ? <FaExclamationTriangle /> : <FaCheckCircle />}
              </span>
              <div>
                <span className="water-diagnosis-eyebrow">Diagnóstico do período</span>
                <h4>
                  {diagnosticoHidrico.deficit ? 'Déficit hídrico acumulado' : 'Saldo hídrico positivo'}
                </h4>
                <strong>{diagnosticoHidrico.saldo > 0 ? '+' : ''}{diagnosticoHidrico.saldo.toFixed(1)} mm</strong>
                <p>
                  {diagnosticoHidrico.deficit
                    ? `A precipitação repôs ${diagnosticoHidrico.coberturaDemanda?.toFixed(0) || 0}% da evapotranspiração de referência estimada.`
                    : 'A precipitação acumulada superou a evapotranspiração de referência estimada.'}
                </p>
              </div>
            </div>

            <div className="water-demand-panel">
              <div className="water-demand-heading">
                <span>Atendimento da demanda atmosférica</span>
                <strong>{diagnosticoHidrico.coberturaDemanda?.toFixed(0) || 0}%</strong>
              </div>
              <div className="water-demand-track">
                <span style={{ width: `${diagnosticoHidrico.coberturaVisual}%` }} />
              </div>
              <div className="water-demand-caption">
                <span><FaCloudRain /> Chuva {balanco.totalPrecipitacao} mm</span>
                <span><FaTint /> ETo {balanco.totalETP} mm</span>
              </div>
              <small>ETo é a demanda de uma cultura de referência; a necessidade da cultura depende do Kc e do manejo do solo.</small>
            </div>
          </section>

          <section className="water-primary-metrics" aria-label="Indicadores climáticos principais do talhão">
            <article className="water-primary-card is-rain">
              <span className="water-metric-icon"><FaCloudRain /></span>
              <div><span>Precipitação acumulada</span><strong>{balanco.totalPrecipitacao}<small> mm</small></strong></div>
              <em>{diagnosticoHidrico.precipitacaoMediaDia.toFixed(2)} mm/dia</em>
            </article>
            <article className="water-primary-card is-demand">
              <span className="water-metric-icon"><FaTint /></span>
              <div><span>ETo acumulada</span><strong>{balanco.totalETP}<small> mm</small></strong></div>
              <em>{diagnosticoHidrico.etoMediaDia.toFixed(2)} mm/dia</em>
            </article>
            <article className={`water-primary-card ${diagnosticoHidrico.deficit ? 'is-balance-deficit' : 'is-balance-surplus'}`}>
              <span className="water-metric-icon">{diagnosticoHidrico.deficit ? <FaArrowDown /> : <FaArrowUp />}</span>
              <div><span>Saldo do período</span><strong>{diagnosticoHidrico.saldo > 0 ? '+' : ''}{balanco.balanco}<small> mm</small></strong></div>
              <em>{diagnosticoHidrico.saldoMedioDia > 0 ? '+' : ''}{diagnosticoHidrico.saldoMedioDia.toFixed(2)} mm/dia</em>
            </article>
          </section>

          <section className="water-secondary-metrics" aria-label="Condições médias e cobertura dos dados">
            <article><FaTemperatureHigh /><div><span>Temperatura média</span><strong>{balanco.mediaTemp}°C</strong></div></article>
            <article><FaTint /><div><span>Umidade média</span><strong>{balanco.mediaUmidade}%</strong></div></article>
            <article><FaCalendarAlt /><div><span>Período analisado</span><strong>{balanco.diasAnalisados} dias</strong></div></article>
            <article><FaShieldAlt /><div><span>Cobertura dos dados</span><strong>{diagnosticoHidrico.coberturaDados}%</strong></div></article>
          </section>

          <section className="water-insights-section">
            <div className="water-section-title">
              <div><span>Leitura aprofundada</span><h4>Comportamento do período</h4></div>
              <span className="water-period-chip"><FaCalendarAlt /> {diagnosticoHidrico.periodoNome}</span>
            </div>
            <div className="water-insights-grid">
              <article><span>Dias com chuva</span><strong>{diagnosticoHidrico.diasComChuva}</strong><small>registros acima de 0 mm</small></article>
              <article><span>Maior sequência sem chuva</span><strong>{diagnosticoHidrico.maiorSequenciaSemChuva} dias</strong><small>no intervalo analisado</small></article>
              <article><span>Maior chuva diária</span><strong>{diagnosticoHidrico.maiorChuva ? `${diagnosticoHidrico.maiorChuva.valor.toFixed(1)} mm` : '—'}</strong><small>{diagnosticoHidrico.maiorChuvaData}</small></article>
              <article><span>Temperatura máxima</span><strong>{diagnosticoHidrico.temperaturaMaxima == null ? '—' : `${diagnosticoHidrico.temperaturaMaxima.toFixed(1)}°C`}</strong><small>maior valor diário</small></article>
              <article><span>Temperatura mínima</span><strong>{diagnosticoHidrico.temperaturaMinima == null ? '—' : `${diagnosticoHidrico.temperaturaMinima.toFixed(1)}°C`}</strong><small>menor valor diário</small></article>
              <article><span>Intervalo efetivo</span><strong>{balanco.diasAnalisados} dias</strong><small>{diagnosticoHidrico.periodoReal}</small></article>
            </div>
          </section>

          <section className="water-data-quality">
            <div className="water-quality-heading">
              <FaShieldAlt />
              <div><h4>Confiabilidade da análise</h4><p>Cobertura mínima entre chuva, temperatura e umidade.</p></div>
              <strong>{diagnosticoHidrico.coberturaDados}%</strong>
            </div>
            <div className="water-quality-track"><span style={{ width: `${diagnosticoHidrico.coberturaDados}%` }} /></div>
            <div className="water-quality-details">
              <span>Chuva: {balanco.dadosValidos.precipitacao} dias</span>
              <span>Temperatura: {balanco.dadosValidos.temperatura} dias</span>
              <span>Umidade: {balanco.dadosValidos.umidade} dias</span>
              <span>Solicitados: {diagnosticoHidrico.diasEsperados} dias</span>
            </div>
            {diagnosticoHidrico.diasAusentes > 0 && (
              <p className="water-quality-warning" role="status">
                <FaExclamationTriangle /> Faltam {diagnosticoHidrico.diasAusentes} dia(s) no intervalo solicitado. O cálculo usa somente os dias disponíveis.
              </p>
            )}
          </section>
        </>
      )}

      {/* Comparação Histórica */}
      {balanco && (() => {
        const MESES = ['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'];
        const DIAS_MES = [31,28,31,30,31,30,31,31,30,31,30,31];
        const calcNormal = () => {
          if (!climatologia) return null;
          // Usa o mesmo período que calcularBalancoFiltrado: fase selecionada tem prioridade
          let ini, fim;
          if (faseSelecionada && fases[faseSelecionada]) {
            ini = fases[faseSelecionada].ini;
            fim = fases[faseSelecionada].fim;
          } else if (dataInicioFiltro && dataFimFiltro) {
            ini = new Date(dataInicioFiltro);
            fim = new Date(dataFimFiltro);
          } else {
            return null;
          }
          // Limitar fim à última data com dado real disponível dentro do intervalo,
          // para que a normal cubra exatamente o mesmo período que o balanço calculado
          // (evita comparar contra dias futuros da fase em andamento).
          if (dadosClima?.properties?.parameter?.PRECTOTCORR) {
            const precipitacao = dadosClima.properties.parameter.PRECTOTCORR;
            let ultimaData = null;
            Object.keys(precipitacao).forEach(dataStr => {
              const norm = dataStr.length === 8
                ? `${dataStr.slice(0,4)}-${dataStr.slice(4,6)}-${dataStr.slice(6,8)}`
                : dataStr;
              const d = new Date(norm);
              if (d >= ini && d <= fim) {
                if (!ultimaData || d > ultimaData) ultimaData = d;
              }
            });
            if (ultimaData && ultimaData < fim) fim = ultimaData;
          }
          let precTotal = 0, tempSoma = 0, diasTotal = 0;
          let cur = new Date(ini.getFullYear(), ini.getMonth(), 1);
          while (cur <= fim) {
            const mesIdx = cur.getMonth();
            const mesKey = MESES[mesIdx];
            const inicioMes = new Date(cur.getFullYear(), cur.getMonth(), 1);
            const fimMes = new Date(cur.getFullYear(), cur.getMonth() + 1, 0);
            const cobIni = ini > inicioMes ? ini : inicioMes;
            const cobFim = fim < fimMes ? fim : fimMes;
            const dias = Math.max(0, Math.round((cobFim - cobIni) / 86400000) + 1);
            precTotal += (climatologia.PRECTOTCORR?.[mesKey] ?? 0) * dias;
            tempSoma  += (climatologia.T2M?.[mesKey] ?? 0) * dias;
            diasTotal += dias;
            cur.setMonth(cur.getMonth() + 1);
          }
          return {
            precTotal: precTotal.toFixed(1),
            tempMedia: diasTotal > 0 ? (tempSoma / diasTotal).toFixed(1) : null
          };
        };
        const normal = calcNormal();
        if (!normal) return loadingClimatologia ? (
          <div style={{ marginTop: 16, fontSize: 12, color: '#888', textAlign: 'center' }}>⏳ Carregando médias históricas...</div>
        ) : null;
        const precAtual  = parseFloat(balanco.totalPrecipitacao);
        const precNormal = parseFloat(normal.precTotal);
        const precDelta  = (precAtual - precNormal).toFixed(1);
        const tempAtual  = parseFloat(balanco.mediaTemp);
        const tempNormal = parseFloat(normal.tempMedia);
        const tempDelta  = (tempAtual - tempNormal).toFixed(1);
        const precAcima  = precAtual >= precNormal;
        const tempAcima  = parseFloat(tempDelta) > 0;
        return (
          <section className="water-history-section">
            <div className="water-section-title">
              <div><span>Contexto climático</span><h4>Comparação com a normal histórica</h4></div>
              <span className="water-history-period">1991–2020</span>
            </div>
            <div className="water-history-grid">
              <article className="is-rain">
                <div className="water-history-icon"><FaCloudRain /></div>
                <div className="water-history-copy"><span>Precipitação</span><strong>{balanco.totalPrecipitacao} mm</strong><small>Normal: {normal.precTotal} mm</small></div>
                <span className={`water-history-delta ${precAcima ? 'is-positive' : 'is-negative'}`}>
                  {precAcima ? <FaArrowUp /> : <FaArrowDown />}
                  {Math.abs(precDelta)} mm
                  <small>{precNormal > 0 ? `${Math.abs(((precAtual / precNormal - 1) * 100)).toFixed(0)}%` : '—'}</small>
                </span>
              </article>
              <article className="is-temperature">
                <div className="water-history-icon"><FaTemperatureHigh /></div>
                <div className="water-history-copy"><span>Temperatura média</span><strong>{balanco.mediaTemp}°C</strong><small>Normal: {normal.tempMedia}°C</small></div>
                <span className={`water-history-delta ${tempAcima ? 'is-warm' : 'is-positive'}`}>
                  {tempAcima ? <FaArrowUp /> : <FaArrowDown />}
                  {Math.abs(tempDelta)}°C
                </span>
              </article>
            </div>
            <div className="water-history-source"><FaInfoCircle /> Fonte: NASA POWER Climatology 1991–2020</div>
          </section>
        );
      })()}

      {/* Histórico removido. O card principal sempre reflete o filtro selecionado. */}

      {/* Seção dos Gráficos de Tendência */}
      {mostrarGraficos && (
        <section className="water-charts-section" style={{
          marginTop: 20,
          padding: 16,
          background: '#f8f9fa',
          borderRadius: 8,
          border: '1px solid #dee2e6'
        }}>
          <h4 style={{ color: '#9c27b0', margin: '0 0 12px 0' }}>
            <FaChartLine /> Evolução meteorológica do ciclo
            {dadosDiarios.length > 0 && (
              <span style={{ fontSize: 12, fontWeight: 'normal', color: '#666' }}>
                <br />
                {talhao.data_plantio 
                  ? `Plantio: ${new Date(talhao.data_plantio + 'T12:00:00').toLocaleDateString('pt-BR')}`
                  : 'Sem data de plantio'
                }
              </span>
            )}
          </h4>
          {dadosDiarios.length > 0 ? (
            <>
              {/* Novo gráfico com ApexCharts */}
              <div style={{ marginBottom: 16 }}>
                <GraficoHistoricoApex dados={dadosDiarios} />
              </div>
              <div style={{
                marginTop: 12,
                padding: 12,
                background: '#e8f5e9',
                borderRadius: 6,
                border: '1px solid #4caf50',
                fontSize: 12
              }}>
                <div style={{ display: 'flex', gap: 20, justifyContent: 'center', flexWrap: 'wrap' }}>
                  <div>
                    <strong style={{ color: '#2196f3' }}>📊 Precipitação:</strong>
                    <span style={{ marginLeft: 8 }}>
                      Total: {dadosDiarios.reduce((acc, item) => acc + item.precipitacao, 0).toFixed(1)} mm
                    </span>
                  </div>
                  <div>
                    <strong style={{ color: '#ff9800' }}>🌡️ ET0:</strong>
                    <span style={{ marginLeft: 8 }}>
                      Total: {dadosDiarios.reduce((acc, item) => acc + item.et0, 0).toFixed(1)} mm
                    </span>
                  </div>
                  <div>
                    <strong style={{ color: '#9c27b0' }}>⚖️ Diferença:</strong>
                    <span style={{ marginLeft: 8 }}>
                      {(dadosDiarios.reduce((acc, item) => acc + item.precipitacao, 0) - 
                        dadosDiarios.reduce((acc, item) => acc + item.et0, 0)).toFixed(1)} mm
                    </span>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <div style={{ color: '#888', textAlign: 'center', padding: 24 }}>
              Nenhum dado diário encontrado para o período.
            </div>
          )}
        </section>
      )}

      <div className="water-method-note" style={{
        marginTop: 12,
        fontSize: 11,
        color: '#666',
        textAlign: 'center',
        fontStyle: 'italic'
      }}>
        <FaInfoCircle /> Dados NASA POWER •
        {talhao.data_plantio 
          ? `Desde o plantio (${new Date(talhao.data_plantio + 'T12:00:00').toLocaleDateString('pt-BR')})${talhao.data_colheita ? ` até colheita (${new Date(talhao.data_colheita + 'T12:00:00').toLocaleDateString('pt-BR')})` : ''}`
          : 'Últimos 30 dias'
        }
      </div>
    </div>
  );
}


function formatarPeriodoPrevisao(label) {
  const match = label?.match(/(\d{4})-(\d{2})-(\d{2})\s*-\s*(\d{4})-(\d{2})-(\d{2})/);
  if (!match) return label || 'Período não informado';
  const meses = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];
  const mesmoMes = match[2] === match[5];
  return mesmoMes
    ? `${match[3]} a ${match[6]} de ${meses[Number(match[2]) - 1]}`
    : `${match[3]} de ${meses[Number(match[2]) - 1]} a ${match[6]} de ${meses[Number(match[5]) - 1]}`;
}

function PrevisaoSemanalTalhao({ previsao, loading }) {
  if (loading) {
    return (
      <section className="plot-forecast-panel">
        <div className="plot-forecast-loading"><span /> Carregando previsão semanal...</div>
      </section>
    );
  }

  if (previsao?.error) {
    return <section className="plot-forecast-panel"><div className="plot-forecast-error"><FaExclamationTriangle /> {previsao.error}</div></section>;
  }

  if (!previsao) {
    return <section className="plot-forecast-panel"><div className="plot-forecast-empty"><FaInfoCircle /> Nenhum dado de previsão encontrado para este talhão.</div></section>;
  }

  const keys = Object.keys(previsao);
  const getDate = (key) => key.match(/(\d{4}-\d{2}-\d{2})/)?.[0] || '';
  const anomaliaCols = keys.filter((key) => key.toLowerCase().includes('anomalia')).sort((a, b) => getDate(a).localeCompare(getDate(b)));
  const chuvaCols = keys.filter((key) => key.toLowerCase().includes('chuva')).sort((a, b) => getDate(a).localeCompare(getDate(b)));
  const quantidadeSemanas = Math.min(2, Math.max(anomaliaCols.length, chuvaCols.length));

  const toNumber = (value) => {
    if (value === null || value === undefined || value === '') return null;
    const numero = Number(value);
    return Number.isFinite(numero) ? numero : null;
  };

  const semanas = Array.from({ length: quantidadeSemanas }, (_, idx) => {
    const label = anomaliaCols[idx]?.replace(/^anomalia\s*/i, '') || chuvaCols[idx]?.replace(/^chuva\s*/i, '');
    const anomalia = toNumber(previsao[anomaliaCols[idx]]);
    const chuva = toNumber(previsao[chuvaCols[idx]]);
    return { label, anomalia, chuva, idx };
  }).filter((semana) => semana.anomalia !== null || semana.chuva !== null);

  if (!semanas.length) {
    return <section className="plot-forecast-panel"><div className="plot-forecast-empty"><FaInfoCircle /> A fonte não retornou valores semanais válidos.</div></section>;
  }

  const semanasComChuva = semanas.filter((semana) => semana.chuva !== null);
  const semanasComAnomalia = semanas.filter((semana) => semana.anomalia !== null);
  const chuvaTotal = semanasComChuva.reduce((total, semana) => total + semana.chuva, 0);
  const anomaliaMedia = semanasComAnomalia.length
    ? semanasComAnomalia.reduce((total, semana) => total + semana.anomalia, 0) / semanasComAnomalia.length
    : null;
  const semanasAbaixo = semanasComAnomalia.filter((semana) => semana.anomalia < 0).length;
  const tendencia = anomaliaMedia === null ? 'Sem comparação histórica' : anomaliaMedia < 0 ? 'Abaixo da média' : anomaliaMedia > 0 ? 'Acima da média' : 'Próximo da média';

  const classificarChuva = (chuva) => {
    if (chuva === null) return 'Sem estimativa de volume';
    if (chuva < 1) return 'Chuva pouco expressiva';
    if (chuva < 10) return 'Baixo volume previsto';
    if (chuva < 30) return 'Volume moderado previsto';
    return 'Volume elevado previsto';
  };

  return (
    <section className="plot-forecast-panel">
      <header className="plot-forecast-header">
        <div>
          <span className="plot-forecast-eyebrow"><FaCloudRain /> Perspectiva do talhão</span>
          <h3>Previsão semanal</h3>
          <p>Chuva estimada e comportamento em relação à média histórica para as próximas duas semanas.</p>
        </div>
        <span className={`plot-forecast-trend ${anomaliaMedia !== null && anomaliaMedia < 0 ? 'is-below' : 'is-above'}`}>
          {anomaliaMedia !== null && anomaliaMedia < 0 ? <FaArrowDown /> : <FaArrowUp />}
          {tendencia}
        </span>
      </header>

      <div className={`plot-forecast-hero ${chuvaTotal < 1 ? 'is-dry' : 'is-rainy'}`}>
        <div className="plot-forecast-total">
          <span>Chuva prevista em {semanas.length === 1 ? '7 dias' : '14 dias'}</span>
          <strong>{chuvaTotal.toFixed(2)}<small> mm</small></strong>
          <p>{classificarChuva(chuvaTotal)} no período consolidado.</p>
        </div>
        <div className="plot-forecast-comparison">
          <div>
            <span>Semanas abaixo da média</span>
            <strong>{semanasAbaixo}<small> de {semanasComAnomalia.length}</small></strong>
          </div>
          <div>
            <span>Índice médio de anomalia</span>
            <strong>{anomaliaMedia === null ? '—' : `${anomaliaMedia > 0 ? '+' : ''}${anomaliaMedia.toFixed(2)}`}</strong>
          </div>
        </div>
      </div>

      <div className="plot-forecast-section-title">
        <div><span>Detalhamento</span><h4>Comparação semanal</h4></div>
        <span>Modelo GFS</span>
      </div>

      <div className="plot-forecast-weeks">
        {semanas.map((semana) => {
          const abaixo = semana.anomalia !== null && semana.anomalia < 0;
          return (
            <article className={`plot-forecast-week ${abaixo ? 'is-below' : 'is-above'}`} key={`${semana.label}-${semana.idx}`}>
              <div className="plot-forecast-week-top">
                <span className="plot-forecast-week-number">{semana.idx === 0 ? 'Próximos 7 dias' : 'Semana seguinte'}</span>
                <span className={`plot-forecast-week-status ${abaixo ? 'is-below' : 'is-above'}`}>
                  {abaixo ? <FaArrowDown /> : <FaArrowUp />}
                  {semana.anomalia === null ? 'Sem comparativo' : abaixo ? 'Abaixo da média' : semana.anomalia > 0 ? 'Acima da média' : 'Na média'}
                </span>
              </div>
              <h5><FaCalendarAlt /> {formatarPeriodoPrevisao(semana.label)}</h5>
              <div className="plot-forecast-week-metrics">
                <div><span><FaCloudRain /> Chuva prevista</span><strong>{semana.chuva === null ? '—' : `${semana.chuva.toFixed(2)} mm`}</strong><small>{classificarChuva(semana.chuva)}</small></div>
                <div><span><FaChartLine /> Anomalia</span><strong>{semana.anomalia === null ? '—' : `${semana.anomalia > 0 ? '+' : ''}${semana.anomalia.toFixed(2)}`}</strong><small>índice em relação à média</small></div>
              </div>
            </article>
          );
        })}
      </div>

      <footer className="plot-forecast-note">
        <FaInfoCircle />
        <div><strong>Como interpretar</strong><span>A chuva representa o acumulado previsto. A anomalia é um índice comparativo: valores negativos indicam tendência abaixo da média histórica e positivos, acima.</span></div>
      </footer>
    </section>
  );
}


// --- COMPONENTE PRINCIPAL COM ABAS ---
export default function DentroTalhoes({ talhao, user, onVoltar, permission = 'owner', initialSection = null, backLabel = '← Voltar para lista de talhões' }) {
  const statusTalhao = getTalhaoStatus(talhao);
  const { darkMode } = useContext(ThemeContext);
  const [subAba, setSubAba] = useState(
    (statusTalhao === 'planejado'
      ? ['planejamento', 'previsao', 'fotos', 'info']
      : ['fenologia', 'balanco', 'previsao', 'fotos', 'info']).includes(initialSection)
      ? initialSection
      : statusTalhao === 'planejado' ? 'planejamento' : 'fenologia'
  );
  const [previsao, setPrevisao] = useState(null);
  const [loadingPrevisao, setLoadingPrevisao] = useState(false);
  const [mostrarAtalhos, setMostrarAtalhos] = useState(false);
  const [gerandoRelatorio, setGerandoRelatorio] = useState(false);
  
  // Permissão: 'owner' e 'editor' podem editar, 'viewer' só visualiza
  const podeEditar = permission === 'owner' || permission === 'editor';
  
  // Hook de verificação de plano
  const { podeUsar, loading: planLoading } = usePlanLimits(user?.id);
  // Evita mostrar cadeado de bloqueio antes do plano terminar de carregar
  const podeUsarPdf = planLoading || podeUsar('relatorios_pdf');
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  
  // Detecta se está rodando no desktop (Electron) ou mobile (Capacitor)
  const isCapacitor = Capacitor.isNativePlatform();
  const isDesktop = !isCapacitor && window.navigator.userAgent.includes('Electron');
  const isLargeScreen = window.innerWidth >= 768;
  
  // Atalhos de teclado (apenas desktop)
  useEffect(() => {
    if (!isDesktop) return;
    
    const handleKeyPress = (e) => {
      // Ctrl + números para trocar abas
      if (e.ctrlKey && !e.shiftKey && !e.altKey) {
        switch(e.key) {
          case '1':
            e.preventDefault();
            setSubAba('fenologia');
            break;
          case '2':
            e.preventDefault();
            setSubAba('balanco');
            break;
          case '3':
            e.preventDefault();
            setSubAba('previsao');
            break;
          case '4':
            e.preventDefault();
            setSubAba('fotos');
            break;
          case '5':
            e.preventDefault();
            setSubAba('info');
            break;
          case 'p':
          case 'P':
            e.preventDefault();
            exportarPDF();
            break;
          case 'h':
          case 'H':
            e.preventDefault();
            setMostrarAtalhos(!mostrarAtalhos);
            break;
          default:
            break;
        }
      }
    };
    
    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, [isDesktop, mostrarAtalhos, subAba]);

  useEffect(() => {
    if (subAba === 'eventos') {
      setSubAba(statusTalhao === 'planejado' ? 'planejamento' : 'fenologia');
    }
  }, [statusTalhao, subAba]);
  
  // Função para exportar PDF da aba atual
  const exportarPDF = () => {
    // Verifica se o usuário tem permissão para gerar relatórios PDF
    if (!podeUsar('relatorios_pdf')) {
      setShowUpgradeModal(true);
      return;
    }
    
    const doc = new jsPDF();
    const titulo = `${talhao.nome} - ${subAba.charAt(0).toUpperCase() + subAba.slice(1)}`;
    
    doc.setFontSize(16);
    doc.text(titulo, 20, 20);
    doc.setFontSize(12);
    doc.text(`Cultura: ${talhao.cultura || 'N/A'}`, 20, 30);
    doc.text(`Área: ${talhao.area_ha || 'N/A'} ha`, 20, 40);
    doc.text(`Data: ${new Date().toLocaleDateString('pt-BR')}`, 20, 50);
    
    doc.save(`${talhao.nome}_${subAba}_${localDateStr()}.pdf`);
  };

  // ─── Relatório Completo do Talhão (pdfmake) ──────────────────────────────
  const exportarRelatorioTalhao = async () => {
    if (!podeUsar('relatorios_pdf')) { setShowUpgradeModal(true); return; }
    setGerandoRelatorio(true);
    try {
      // Logo
      async function getLogoBase64() {
        try {
          const res = await fetch('/ClimoraX_vertical.png');
          const blob = await res.blob();
          return new Promise(resolve => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(blob);
          });
        } catch { return null; }
      }
      const logoBase64 = await getLogoBase64();

      // Fenologia
      const fasesDef = [
        { nome: 'Emergência',           diasIni: 0,  icone: '🌱' },
        { nome: 'Crescimento Vegetativo', diasIni: 10, icone: '🌿' },
        { nome: 'Florescimento',         diasIni: 40, icone: '🌸' },
        { nome: 'Enchimento de Grãos',   diasIni: 60, icone: '🌾' },
        { nome: 'Maturação',             diasIni: 90, icone: '✅' },
      ];
      const diasDesdePlantio = talhao?.data_plantio
        ? Math.floor((new Date() - new Date(talhao.data_plantio)) / 86400000) : null;
      let faseAtualIdx = 0;
      if (diasDesdePlantio !== null) {
        for (let i = 0; i < fasesDef.length; i++) {
          if (diasDesdePlantio >= fasesDef[i].diasIni) faseAtualIdx = i;
        }
      }
      const faseAtual = fasesDef[faseAtualIdx];

      // Dados climáticos do balanço — ciclo completo (data_plantio → hoje ou data_colheita)
      let dadosBalanco = [];
      let totalChuva30 = '-', tempMedia30 = '-', totalETP30 = '-', saldoHidrico = '-';
      let labelPeriodo = 'Ciclo Completo';
      try {
        const { DadosMeteorologicosService } = await import('../services/DadosMeteorologicosService');
        const hoje = new Date();
        const fimDate = talhao.data_colheita ? new Date(talhao.data_colheita) : hoje;
        const fim = fimDate < hoje ? fimDate : hoje;
        const ini = talhao.data_plantio ? new Date(talhao.data_plantio) : new Date(hoje.getTime() - 30 * 86400000);
        const iniStr = talhao.data_plantio ? talhao.data_plantio.slice(0, 10) : localDateStr(ini);
        const fimStr = (talhao.data_colheita && fimDate < hoje) ? talhao.data_colheita.slice(0, 10) : localDateStr(fim);
        const diasPeriodo = Math.round((fim - ini) / 86400000);
        labelPeriodo = `${diasPeriodo} dias (${iniStr.split('-').reverse().join('/')} → ${fimStr.split('-').reverse().join('/')})`;
        dadosBalanco = await DadosMeteorologicosService.buscarDadosCache(talhao.id, iniStr, fimStr) || [];
        if (dadosBalanco.length) {
          const chuvas = dadosBalanco.map(d => Number(d.precipitacao) || 0);
          const temps = dadosBalanco.map(d => ((Number(d.temp_max) + Number(d.temp_min)) / 2)).filter(v => !isNaN(v));
          const etps = dadosBalanco.map(d => Number(d.etp) || Number(d.et0) || 0);
          totalChuva30 = chuvas.reduce((a, b) => a + b, 0).toFixed(1);
          tempMedia30 = temps.length ? (temps.reduce((a, b) => a + b, 0) / temps.length).toFixed(1) : '-';
          totalETP30 = etps.reduce((a, b) => a + b, 0).toFixed(1);
          saldoHidrico = (Number(totalChuva30) - Number(totalETP30)).toFixed(1);
        }
      } catch (e) { console.warn('Balanço não disponível para relatório', e); }

      // Previsão 7 dias
      let previsaoData = null;
      try {
        if (talhao?.coordenada_x && talhao?.coordenada_y) {
          const { data } = await supabase.rpc('nearest_weekly_gfs_forecast', {
            x: talhao.coordenada_x, y: talhao.coordenada_y
          });
          previsaoData = data?.[0] || null;
        }
      } catch (e) { /* sem previsão */ }

      // Eventos recentes
      let eventos = [];
      try {
        const { data: evData } = await supabase
          .from('eventos_talhao')
          .select('*')
          .eq('talhao_id', talhao.id)
          .order('data_evento', { ascending: false })
          .limit(8);
        eventos = evData || [];
      } catch (e) { /* sem eventos */ }

      // Custos da lavoura
      let eventosComCusto = [];
      try {
        const { data: custoData } = await supabase
          .from('eventos_talhao')
          .select('tipo, titulo, data_evento, custo_total, custo_detalhes')
          .eq('talhao_id', talhao.id)
          .not('custo_total', 'is', null)
          .gt('custo_total', 0)
          .order('data_evento', { ascending: false });
        eventosComCusto = custoData || [];
      } catch (e) { /* sem custos */ }
      const totalCustos = eventosComCusto.reduce((s, e) => s + (Number(e.custo_total) || 0), 0);
      const areaHaTalhao = parseFloat(talhao.area || talhao.area_ha) || null;
      const custoPorHa = areaHaTalhao && totalCustos > 0 ? totalCustos / areaHaTalhao : null;
      const custosPorTipo = {};
      eventosComCusto.forEach(e => { custosPorTipo[e.tipo] = (custosPorTipo[e.tipo] || 0) + (Number(e.custo_total) || 0); });
      const CUSTO_LABELS_PDF = {
        produto:'Produto/Insumo', mao_de_obra:'Mão de obra', maquinario:'Maquinário',
        energia:'Energia elétrica', manutencao:'Manutenção', laudo:'Laudo/Análise',
        coleta:'Coleta (M.O.)', pecas:'Peças/Materiais', outros:'Outros'
      };
      const TIPO_LABELS_PDF = {
        aplicacao:'Aplicacao', operacao:'Operacao', irrigacao:'Irrigacao',
        analise:'Analise', manutencao:'Manutencao', doenca:'Doenca/Praga',
        observacao:'Observacao', problema:'Problema', monitoramento:'Monitoramento'
      };
      const fmtBRL = (v) => Number(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
      let dadosZARC = null, dadosKoppen = null, etoProjeto = null;
      try {
        // 1. Buscar code_muni da propriedade
        let codeMuni = null;
        if (talhao?.propriedade_id) {
          const { data: propData } = await supabase
            .from('propriedades')
            .select('code_muni')
            .eq('id', talhao.propriedade_id)
            .single();
          codeMuni = propData?.code_muni || null;
        }
        // 2. ZARC
        if (codeMuni && talhao?.cultura) {
          const { buscarDadosZARC } = await import('../services/zarcService');
          dadosZARC = await buscarDadosZARC(codeMuni, talhao.cultura);
        }
        // 3. Köppen
        if (codeMuni) {
          const { data: kData } = await supabase
            .from('clima_koppen_data')
            .select('koppen')
            .eq('code_muni', codeMuni)
            .single();
          dadosKoppen = kData?.koppen || null;
        }
        // 4. ETo de Projeto
        if (talhao?.coordenada_x && talhao?.coordenada_y) {
          const lat = parseFloat(talhao.coordenada_y);
          const lon = parseFloat(talhao.coordenada_x);
          const raio = 0.5;
          const { data: etoData } = await supabase
            .from('eto_projeto_data')
            .select('"X", "Y", "Eto_projeto"')
            .gte('Y', lat - raio).lte('Y', lat + raio)
            .gte('X', lon - raio).lte('X', lon + raio)
            .limit(50);
          if (etoData?.length) {
            const sorted = etoData
              .map(p => ({ ...p, dist: Math.sqrt((parseFloat(p.X)-lon)**2 + (parseFloat(p.Y)-lat)**2) }))
              .sort((a, b) => a.dist - b.dist);
            etoProjeto = sorted[0]?.Eto_projeto != null ? parseFloat(sorted[0].Eto_projeto).toFixed(2) : null;
          }
        }
      } catch (e) { console.warn('Dados agronômicos não disponíveis para relatório', e); }

      // Mapeamento Köppen → descrição
      const koppenDesc = {
        'Af':'Tropical úmido, chuvas o ano todo','Am':'Tropical de monção',
        'Aw':'Tropical com estação seca (inverno)','As':'Tropical com estação seca (verão)',
        'BWh':'Desértico quente','BWk':'Desértico frio','BSh':'Semiárido quente','BSk':'Semiárido frio',
        'Cfa':'Subtropical úmido, verão quente','Cfb':'Temperado oceânico, verão ameno',
        'Cwa':'Temperado com inverno seco e verão quente','Cwb':'Temperado de altitude, inverno seco',
        'Csa':'Mediterrâneo, verão quente','Csb':'Mediterrâneo, verão ameno',
      };
      const koppenLabel = dadosKoppen
        ? `${dadosKoppen} — ${koppenDesc[dadosKoppen] || 'Classificação climática Köppen'}`
        : null;

      // ─── Helpers visuais ────────────────────────────────────────────────
      const PAD_L = 30, INNER_L = 2, PAD_T = 4, PAD_B = 4, CHART_H = 80, CHART_W = 480;
      const innerPlotW = CHART_W - PAD_L - INNER_L - 4;
      const innerPlotH = CHART_H - PAD_T - PAD_B;

      function niceAxis(rawMin, rawMax) {
        const range = (rawMax - rawMin) || 2;
        const roughStep = range / 4;
        const mag = Math.pow(10, Math.floor(Math.log10(roughStep || 1)));
        const step = [1, 2, 2.5, 5, 10].map(c => c * mag).find(s => s >= roughStep) || mag * 10;
        const lo = Math.floor(rawMin / step) * step;
        const hi = Math.ceil(rawMax / step) * step;
        const ticks = [];
        for (let v = lo; v <= hi + step * 0.001; v += step) ticks.push(Math.round(v * 10000) / 10000);
        return ticks;
      }

      function buildBarChartSimple(values, color) {
        const positives = values.filter(v => v != null && v > 0);
        if (!positives.length) return [];
        const maxV = Math.max(...positives) * 1.1 || 1;
        const n = values.length;
        const barW = Math.max(2, innerPlotW / n - 1.5);
        const x0 = INNER_L, y0 = PAD_T, y1 = PAD_T + innerPlotH;
        const shapes = [];
        shapes.push({ type: 'rect', x: x0, y: y0, w: innerPlotW, h: innerPlotH, color: '#ffffff', lineColor: '#cfd8e3', lineWidth: 0.5 });
        shapes.push({ type: 'line', x1: x0, y1: y1, x2: x0 + innerPlotW, y2: y1, lineWidth: 0.8, lineColor: '#b0bacc' });
        for (let i = 0; i < n; i++) {
          if (!values[i] || values[i] <= 0) continue;
          const bh = Math.min((values[i] / maxV) * innerPlotH, innerPlotH);
          const bx = x0 + i * innerPlotW / n + (innerPlotW / n - barW) / 2;
          shapes.push({ type: 'rect', x: bx, y: y1 - bh, w: barW, h: bh, color, lineWidth: 0 });
        }
        return [{ canvas: shapes, margin: [0, 0, 0, 0] }];
      }

      function buildLineSimple(values, color, fillColor) {
        const valid = values.filter(v => v != null && !isNaN(v));
        if (valid.length < 2) return [];
        const minV = Math.min(...valid), maxV = Math.max(...valid);
        const range = (maxV - minV) || 1;
        const n = values.length;
        const x0 = INNER_L, y0 = PAD_T, y1 = PAD_T + innerPlotH;
        const shapes = [];
        shapes.push({ type: 'rect', x: x0, y: y0, w: innerPlotW, h: innerPlotH, color: '#ffffff', lineColor: '#cfd8e3', lineWidth: 0.5 });
        const pts = [];
        for (let i = 0; i < n; i++) {
          if (values[i] == null || isNaN(values[i])) continue;
          const px = x0 + (n > 1 ? i * innerPlotW / (n - 1) : innerPlotW / 2);
          const py = y0 + innerPlotH - ((values[i] - minV) / range) * innerPlotH;
          pts.push({ x: px, y: py });
        }
        if (pts.length >= 2 && fillColor) {
          const poly = [...pts, { x: pts[pts.length - 1].x, y: y1 }, { x: pts[0].x, y: y1 }];
          shapes.push({ type: 'polyline', points: poly, closePath: true, color: fillColor, lineColor: fillColor, lineWidth: 0 });
        }
        shapes.push({ type: 'line', x1: x0, y1: y1, x2: x0 + innerPlotW, y2: y1, lineWidth: 0.8, lineColor: '#b0bacc' });
        if (pts.length >= 2) shapes.push({ type: 'polyline', lineWidth: 1.5, lineColor: color, closePath: false, points: pts });
        return [{ canvas: shapes, margin: [0, 0, 0, 0] }];
      }

      function xLabels(labels) {
        const nVis = Math.min(labels.length, 8);
        const step = labels.length <= nVis ? 1 : Math.floor((labels.length - 1) / (nVis - 1));
        const items = [];
        for (let i = 0; i < labels.length; i += step) items.push({ text: labels[i], xFrac: i / Math.max(1, labels.length - 1) });
        const W = CHART_W - PAD_L;
        const LW = 28;
        const cols = [];
        let prev = 0;
        for (const it of items) {
          const x = it.xFrac * W;
          const ls = Math.max(prev, x - LW / 2);
          const gap = ls - prev;
          if (gap > 0) cols.push({ text: '', width: gap });
          cols.push({ text: it.text, fontSize: 6, color: '#999', alignment: 'center', width: LW, noWrap: true });
          prev = ls + LW;
        }
        const rem = W - prev;
        if (rem > 0) cols.push({ text: '', width: rem });
        return { columns: cols, margin: [PAD_L, 0, 0, 6], columnGap: 0 };
      }

      function yLabels(ticks, dec = 0) {
        const rev = [...ticks].reverse();
        const n = rev.length;
        const tickGap = innerPlotH / (n - 1);
        const spacer = Math.max(1, PAD_T - 3);
        const heights = [spacer, ...Array(n - 1).fill(tickGap)];
        const body = [
          [{ text: '', border: [false,false,false,false] }],
          ...rev.map(v => [{ text: Number(v).toFixed(dec), fontSize: 6, color: '#777', alignment: 'right', border: [false,false,false,false], margin: [0,0,3,0] }])
        ];
        return {
          width: PAD_L,
          table: { widths: [PAD_L - 3], heights, body },
          layout: { hLineWidth: () => 0, vLineWidth: () => 0, paddingLeft: () => 0, paddingRight: () => 0, paddingTop: () => 0, paddingBottom: () => 0 }
        };
      }

      function sectionTitle(label, color) {
        return {
          columns: [
            { canvas: [{ type: 'rect', x: 0, y: 0, w: 3, h: 11, color, lineWidth: 0 }], width: 7 },
            { text: label, color: '#333', fontSize: 9, bold: true, margin: [0, 1, 0, 0] }
          ],
          margin: [0, 8, 0, 4]
        };
      }

      // ─── Dados para gráficos ────────────────────────────────────────────
      const labels30 = dadosBalanco.map(d => {
        const p = (d.data || '').split('-');
        return p.length === 3 ? `${p[2]}/${p[1]}` : d.data;
      });
      const chuvaVals = dadosBalanco.map(d => Number(d.precipitacao) || 0);
      const chuvaTicks = niceAxis(0, Math.max(...chuvaVals, 1));

      // ─── Balanço por fases fenológicas ───────────────────────────────────
      const balancoPorFaseClean = talhao.data_plantio
        ? fasesDef.map((fase, idx) => {
            const diasFaseIni = fase.diasIni;
            const diasFaseFim = fasesDef[idx + 1] ? fasesDef[idx + 1].diasIni - 1 : 9999;
            const plantioDate = new Date(talhao.data_plantio);
            const diasFiltrados = dadosBalanco.filter(d => {
              if (!d.data) return false;
              const diasD = Math.floor((new Date(d.data) - plantioDate) / 86400000);
              return diasD >= diasFaseIni && diasD <= diasFaseFim;
            });
            if (diasFiltrados.length === 0) return null;
            const chuva = diasFiltrados.reduce((s, d) => s + (Number(d.precipitacao) || 0), 0);
            const eto   = diasFiltrados.reduce((s, d) => s + (Number(d.etp) || Number(d.et0) || 0), 0);
            const saldo = chuva - eto;
            const dIni = Math.floor((new Date(diasFiltrados[0].data) - plantioDate) / 86400000);
            const dFim = Math.floor((new Date(diasFiltrados[diasFiltrados.length - 1].data) - plantioDate) / 86400000);
            // Temperatura média: (temp_max + temp_min) / 2 por dia — igual ao cálculo da aba Balanço
            const tempsValidos = diasFiltrados
              .filter(d => d.temp_max != null && d.temp_min != null && !isNaN(d.temp_max) && !isNaN(d.temp_min)
                        && Number(d.temp_max) >= -50 && Number(d.temp_max) <= 60
                        && Number(d.temp_min) >= -50 && Number(d.temp_min) <= 60)
              .map(d => (Number(d.temp_max) + Number(d.temp_min)) / 2);
            const mediaTemp = tempsValidos.length
              ? (tempsValidos.reduce((s, v) => s + v, 0) / tempsValidos.length)
              : null;
            // Umidade média: campo umidade (RH2M) — igual ao cálculo da aba Balanço
            const umidsValidos = diasFiltrados
              .filter(d => d.umidade != null && !isNaN(d.umidade) && Number(d.umidade) >= 0 && Number(d.umidade) <= 100)
              .map(d => Number(d.umidade));
            const mediaUmidade = umidsValidos.length
              ? (umidsValidos.reduce((s, v) => s + v, 0) / umidsValidos.length)
              : null;
            return { nome: fase.nome, dIni, dFim, n: diasFiltrados.length, chuva, eto, saldo, mediaTemp, mediaUmidade };
          }).filter(Boolean)
        : [];

      // ─── Previsão semanal (anomalia de chuva) ────────────────────────────
      let previsaoRows = [];
      if (previsaoData) {
        const keys = Object.keys(previsaoData);
        const getDateKey = k => { const m = k.match(/(\d{4}-\d{2}-\d{2})/g); return m ? m[0] : ''; };
        const anomaliaCols = keys.filter(k => k.toLowerCase().includes('anomalia')).sort((a,b) => getDateKey(a) > getDateKey(b) ? 1 : -1);
        const chuvaCols    = keys.filter(k => k.toLowerCase().includes('chuva')).sort((a,b) => getDateKey(a) > getDateKey(b) ? 1 : -1);
        const semanas = [0, 1].map(i => ({
          label:    anomaliaCols[i]?.replace('anomalia ', '') || chuvaCols[i]?.replace('chuva ', '') || `Semana ${i+1}`,
          anomalia: previsaoData[anomaliaCols[i]],
          chuva:    previsaoData[chuvaCols[i]],
        })).filter(s => s.anomalia != null || s.chuva != null);
        previsaoRows = semanas.map(s => {
          const anom = s.anomalia != null ? Number(s.anomalia).toFixed(1) : '-';
          const anomCor = s.anomalia != null ? (Number(s.anomalia) >= 0 ? '#2e7d32' : '#c62828') : '#666';
          const anomPrefix = s.anomalia != null && Number(s.anomalia) > 0 ? '+' : '';
          return [
            { text: s.label, fontSize: 7, bold: true, border: [false,false,false,true], borderColor: ['','','','#eee'] },
            { text: s.anomalia != null ? `${anomPrefix}${anom} mm` : '-', fontSize: 7, color: anomCor, alignment: 'center', border: [false,false,false,true], borderColor: ['','','','#eee'] },
            { text: s.chuva != null ? `${Number(s.chuva).toFixed(1)} mm` : '-', fontSize: 7, color: '#0288d1', alignment: 'center', border: [false,false,false,true], borderColor: ['','','','#eee'] },
          ];
        });
      }

      // ─── Fenologia: barra de progresso ───────────────────────────────────
      const totalDiasCiclo = 120;
      const progresso = diasDesdePlantio !== null ? Math.min(diasDesdePlantio / totalDiasCiclo, 1) : 0;
      const faseBarras = fasesDef.map((f, idx) => {
        const ativo = idx === faseAtualIdx;
        return {
          stack: [
            { canvas: [{ type: 'rect', x: 0, y: 0, w: (CHART_W / fasesDef.length) - 2, h: 14, color: ativo ? '#1976d2' : '#e3edf8', lineWidth: 0, radius: 3 }] },
            { text: f.nome, fontSize: 6, color: ativo ? '#fff' : '#666', bold: ativo, alignment: 'center', margin: [0, -12, 0, 0] }
          ],
          width: (CHART_W / fasesDef.length) - 2
        };
      });

      // ─── Eventos (tabela) ─────────────────────────────────────────────────
      const eventoRows = eventos.map(ev => [
        { text: ev.data_evento ? new Date(ev.data_evento).toLocaleDateString('pt-BR') : '-', fontSize: 7, border: [false,false,false,true], borderColor: ['','','','#eee'] },
        { text: ev.tipo || '-', fontSize: 7, bold: true, border: [false,false,false,true], borderColor: ['','','','#eee'] },
        { text: ev.descricao || '-', fontSize: 7, border: [false,false,false,true], borderColor: ['','','','#eee'] },
      ]);

      // ─── Saldo hídrico: cor e label ───────────────────────────────────────
      const saldoNum = parseFloat(saldoHidrico);
      const saldoCor = isNaN(saldoNum) ? '#666' : saldoNum >= 0 ? '#2e7d32' : '#c62828';
      const saldoLabel = isNaN(saldoNum) ? '-' : saldoNum >= 0 ? `+${saldoHidrico} mm ✅` : `${saldoHidrico} mm ⚠️`;

      // ─── Montar docDefinition ─────────────────────────────────────────────
      const fmtData = (str) => {
        if (!str) return '-';
        const p = str.substring(0, 10).split('-');
        return p.length === 3 ? `${p[2]}/${p[1]}/${p[0]}` : str;
      };

      // Safra: usa campo ou calcula pela data de plantio
      const calcSafra = () => {
        if (talhao.safra) return String(talhao.safra);
        if (!talhao.data_plantio) return '-';
        const d = new Date(talhao.data_plantio);
        const ano = d.getFullYear();
        const mes = d.getMonth() + 1; // 1-12
        return mes >= 7 ? `${ano}/${ano + 1}` : `${ano - 1}/${ano}`;
      };
      const safraLabel = calcSafra();

      const docDefinition = {
        pageSize: 'A4',
        pageMargins: [28, 14, 28, 22],
        defaultStyle: { font: 'Roboto' },
        content: [
          // ─ Cabeçalho ─
          {
            columns: [
              ...(logoBase64 ? [{ image: logoBase64, width: 60, height: 60, margin: [0, 0, 10, 0] }] : []),
              {
                stack: [
                  { text: 'Relatório de Talhão', fontSize: 11, bold: true, color: '#003B73' },
                  { text: talhao.nome || '-', fontSize: 16, bold: true, color: '#1976d2', margin: [0, 2, 0, 2] },
                  { text: `Gerado em ${new Date().toLocaleString('pt-BR')}`, fontSize: 7, color: '#999' }
                ],
                margin: [0, 4, 0, 0]
              }
            ],
            margin: [0, 0, 0, 4]
          },
          { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 535, y2: 0, lineWidth: 1, lineColor: '#e0e0e0' }], margin: [0, 0, 0, 8] },

          // ─ Resumo do Talhão (4 cards) ─
          sectionTitle('RESUMO DO TALHÃO', '#1976d2'),
          {
            columns: [
              {
                stack: [
                  { text: 'CULTURA', fontSize: 6.5, color: '#999', bold: true },
                  { text: talhao.cultura || '-', fontSize: 13, bold: true, color: '#1976d2', margin: [0, 2, 0, 0] }
                ],
                width: '*',
                margin: [0, 0, 8, 0],
                style: { background: '#f7faff' }
              },
              {
                stack: [
                  { text: 'ÁREA', fontSize: 6.5, color: '#999', bold: true },
                  { text: (talhao.area || talhao.area_ha) ? `${talhao.area || talhao.area_ha} ha` : '-', fontSize: 13, bold: true, color: '#1976d2', margin: [0, 2, 0, 0] }
                ],
                width: '*',
                margin: [0, 0, 8, 0]
              },
              {
                stack: [
                  { text: 'PLANTIO', fontSize: 6.5, color: '#999', bold: true },
                  { text: fmtData(talhao.data_plantio), fontSize: 11, bold: true, color: '#43a047', margin: [0, 2, 0, 0] }
                ],
                width: '*',
                margin: [0, 0, 8, 0]
              },
              {
                stack: [
                  { text: 'SAFRA', fontSize: 6.5, color: '#999', bold: true },
                  { text: safraLabel, fontSize: 13, bold: true, color: '#555', margin: [0, 2, 0, 0] }
                ],
                width: '*'
              },
            ],
            columnGap: 0,
            margin: [0, 0, 0, 4]
          },
          { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 535, y2: 0, lineWidth: 0.5, lineColor: '#e8e8e8' }], margin: [0, 0, 0, 6] },

          // ─ Fenologia ─
          sectionTitle('FASE FENOLÓGICA ATUAL', '#43a047'),
          {
            columns: faseBarras,
            columnGap: 2,
            margin: [0, 0, 0, 4]
          },
          {
            columns: [
              {
                stack: [
                  { text: `Fase atual: ${faseAtual.nome}`, fontSize: 9, bold: true, color: '#1976d2' },
                  { text: diasDesdePlantio !== null ? `${diasDesdePlantio} dias desde o plantio` : 'Data de plantio não informada', fontSize: 8, color: '#666', margin: [0, 2, 0, 0] },
                ]
              },
              ...(diasDesdePlantio !== null ? [{
                stack: [
                  { text: 'PROGRESSO DO CICLO', fontSize: 6.5, color: '#999', bold: true },
                  {
                    canvas: [
                      { type: 'rect', x: 0, y: 4, w: 160, h: 8, color: '#e3edf8', lineWidth: 0 },
                      { type: 'rect', x: 0, y: 4, w: Math.round(160 * progresso), h: 8, color: '#1976d2', lineWidth: 0 },
                    ]
                  },
                  { text: `${Math.round(progresso * 100)}%`, fontSize: 7, color: '#1976d2', bold: true, margin: [0, 2, 0, 0] }
                ],
                width: 170
              }] : [])
            ],
            margin: [0, 4, 0, 0]
          },
          { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 535, y2: 0, lineWidth: 0.5, lineColor: '#e8e8e8' }], margin: [0, 8, 0, 6] },

          // ─ Balanço Hídrico ─
          sectionTitle(`BALANÇO HÍDRICO — ${labelPeriodo.toUpperCase()}`, '#0288d1'),
          ...(dadosBalanco.length ? [
            // Tabela por fases
            ...(balancoPorFaseClean.length ? [{
              table: {
                widths: ['*', 44, 54, 50, 50, 50, 50],
                body: [
                  [
                    { text: 'FASE', fontSize: 6.5, bold: true, color: '#fff', fillColor: '#1976d2', border: [false,false,false,false], margin: [2,2,2,2] },
                    { text: 'DIAS', fontSize: 6.5, bold: true, color: '#fff', fillColor: '#1976d2', alignment: 'center', border: [false,false,false,false], margin: [2,2,2,2] },
                    { text: 'CHUVA', fontSize: 6.5, bold: true, color: '#fff', fillColor: '#0288d1', alignment: 'center', border: [false,false,false,false], margin: [2,2,2,2] },
                    { text: 'ETo', fontSize: 6.5, bold: true, color: '#fff', fillColor: '#ef6c00', alignment: 'center', border: [false,false,false,false], margin: [2,2,2,2] },
                    { text: 'SALDO', fontSize: 6.5, bold: true, color: '#fff', fillColor: '#546e7a', alignment: 'center', border: [false,false,false,false], margin: [2,2,2,2] },
                    { text: 'T. MÉD.', fontSize: 6.5, bold: true, color: '#fff', fillColor: '#c62828', alignment: 'center', border: [false,false,false,false], margin: [2,2,2,2] },
                    { text: 'UMID.', fontSize: 6.5, bold: true, color: '#fff', fillColor: '#3f51b5', alignment: 'center', border: [false,false,false,false], margin: [2,2,2,2] },
                  ],
                  ...balancoPorFaseClean.map((f, i) => {
                    const saldoCorf = f.saldo >= 0 ? '#1b5e20' : '#b71c1c';
                    const bg = i % 2 === 0 ? '#f7fbff' : '#ffffff';
                    return [
                      { text: f.nome, fontSize: 6.5, bold: true, fillColor: bg, border: [false,false,false,true], borderColor: ['','','','#e8e8e8'], margin: [2,2,2,2] },
                      { text: `${f.dIni}–${f.dFim}d`, fontSize: 6.5, color: '#666', alignment: 'center', fillColor: bg, border: [false,false,false,true], borderColor: ['','','','#e8e8e8'], margin: [2,2,2,2] },
                      { text: `${f.chuva.toFixed(1)} mm`, fontSize: 6.5, color: '#0288d1', alignment: 'center', fillColor: bg, border: [false,false,false,true], borderColor: ['','','','#e8e8e8'], margin: [2,2,2,2] },
                      { text: `${f.eto.toFixed(1)} mm`, fontSize: 6.5, color: '#ef6c00', alignment: 'center', fillColor: bg, border: [false,false,false,true], borderColor: ['','','','#e8e8e8'], margin: [2,2,2,2] },
                      { text: `${f.saldo >= 0 ? '+' : ''}${f.saldo.toFixed(1)} mm`, fontSize: 6.5, bold: true, color: saldoCorf, alignment: 'center', fillColor: bg, border: [false,false,false,true], borderColor: ['','','','#e8e8e8'], margin: [2,2,2,2] },
                      { text: f.mediaTemp != null ? `${f.mediaTemp.toFixed(1)}°C` : '-', fontSize: 6.5, color: '#c62828', alignment: 'center', fillColor: bg, border: [false,false,false,true], borderColor: ['','','','#e8e8e8'], margin: [2,2,2,2] },
                      { text: f.mediaUmidade != null ? `${f.mediaUmidade.toFixed(1)}%` : '-', fontSize: 6.5, color: '#3f51b5', alignment: 'center', fillColor: bg, border: [false,false,false,true], borderColor: ['','','','#e8e8e8'], margin: [2,2,2,2] },
                    ];
                  }),
                  // Linha de total — mediaTemp e Umidade são médias ponderadas pelo nº de dias
                  (() => {
                    const totalN = balancoPorFaseClean.reduce((s, f) => s + f.n, 0);
                    const tempPonderada = balancoPorFaseClean.filter(f => f.mediaTemp != null);
                    const mediaGlobalTemp = tempPonderada.length
                      ? tempPonderada.reduce((s, f) => s + f.mediaTemp * f.n, 0) / tempPonderada.reduce((s, f) => s + f.n, 0)
                      : null;
                    const umidPonderada = balancoPorFaseClean.filter(f => f.mediaUmidade != null);
                    const mediaGlobalUmid = umidPonderada.length
                      ? umidPonderada.reduce((s, f) => s + f.mediaUmidade * f.n, 0) / umidPonderada.reduce((s, f) => s + f.n, 0)
                      : null;
                    return [
                      { text: 'TOTAL', fontSize: 6.5, bold: true, color: '#fff', fillColor: '#37474f', border: [false,false,false,false], margin: [2,3,2,3] },
                      { text: `${totalN}d`, fontSize: 6.5, color: '#ccc', alignment: 'center', fillColor: '#37474f', border: [false,false,false,false], margin: [2,3,2,3] },
                      { text: `${totalChuva30} mm`, fontSize: 6.5, bold: true, color: '#80d8ff', alignment: 'center', fillColor: '#37474f', border: [false,false,false,false], margin: [2,3,2,3] },
                      { text: `${totalETP30} mm`, fontSize: 6.5, bold: true, color: '#ffcc80', alignment: 'center', fillColor: '#37474f', border: [false,false,false,false], margin: [2,3,2,3] },
                      { text: `${saldoNum >= 0 ? '+' : ''}${saldoHidrico} mm`, fontSize: 6.5, bold: true, color: saldoNum >= 0 ? '#a5d6a7' : '#ef9a9a', alignment: 'center', fillColor: '#37474f', border: [false,false,false,false], margin: [2,3,2,3] },
                      { text: mediaGlobalTemp != null ? `${mediaGlobalTemp.toFixed(1)}°C` : `${tempMedia30}°C`, fontSize: 6.5, bold: true, color: '#ef9a9a', alignment: 'center', fillColor: '#37474f', border: [false,false,false,false], margin: [2,3,2,3] },
                      { text: mediaGlobalUmid != null ? `${mediaGlobalUmid.toFixed(1)}%` : '-', fontSize: 6.5, bold: true, color: '#9fa8da', alignment: 'center', fillColor: '#37474f', border: [false,false,false,false], margin: [2,3,2,3] },
                    ];
                  })(),
                ]
              },
              layout: {
                hLineWidth: () => 0,
                vLineWidth: () => 0,
                paddingLeft: () => 0,
                paddingRight: () => 0,
                paddingTop: () => 0,
                paddingBottom: () => 0,
              },
              margin: [0, 0, 0, 10]
            }] : []),
            // Gráfico precipitação diária
            { text: 'Precipitação diária (mm)', fontSize: 7, color: '#555', bold: true, margin: [PAD_L, 0, 0, 2] },
            {
              columns: [
                yLabels(chuvaTicks, 1),
                { width: '*', stack: buildBarChartSimple(chuvaVals, '#29b6f6') }
              ]
            },
            xLabels(labels30),
          ] : [
            { text: 'Dados climáticos não disponíveis. Atualize os dados meteorológicos na aba Clima do Talhão.', fontSize: 8, color: '#888', margin: [0, 4, 0, 8], italics: true }
          ]),

          { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 535, y2: 0, lineWidth: 0.5, lineColor: '#e8e8e8' }], margin: [0, 4, 0, 6] },

          // ─ Previsão 7 dias ─
          sectionTitle('PREVISÃO SEMANAL', '#7b1fa2'),
          ...(previsaoRows.length ? [{
            table: {
              widths: ['*', 90, 80],
              body: [
                [
                  { text: 'PERÍODO', fontSize: 7, bold: true, color: '#999', border: [false,false,false,true], borderColor: ['','','','#ccc'], fillColor: '#f7f7f7' },
                  { text: 'ANOMALIA DE CHUVA', fontSize: 7, bold: true, color: '#999', alignment: 'center', border: [false,false,false,true], borderColor: ['','','','#ccc'], fillColor: '#f7f7f7' },
                  { text: 'CHUVA PREVISTA', fontSize: 7, bold: true, color: '#999', alignment: 'center', border: [false,false,false,true], borderColor: ['','','','#ccc'], fillColor: '#f7f7f7' },
                ],
                ...previsaoRows
              ]
            },
            layout: { hLineWidth: (i, node) => (i === 0 || i === node.table.body.length) ? 0 : 0.5, vLineWidth: () => 0, hLineColor: () => '#eee', paddingLeft: () => 4, paddingRight: () => 4, paddingTop: () => 3, paddingBottom: () => 3 },
            margin: [0, 0, 0, 6]
          }] : [
            { text: 'Previsão não disponível. Verifique se o talhão possui coordenadas cadastradas.', fontSize: 8, color: '#888', italics: true, margin: [0, 0, 0, 8] }
          ]),

          { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 535, y2: 0, lineWidth: 0.5, lineColor: '#e8e8e8' }], margin: [0, 4, 0, 6] },

          // ─ Localização ─
          sectionTitle('LOCALIZAÇÃO', '#546e7a'),
          {
            columns: [
              { stack: [{ text: 'MUNICÍPIO', fontSize: 6.5, color: '#999', bold: true }, { text: talhao.municipio || talhao.propriedade_municipio || '-', fontSize: 11, bold: true, color: '#333', margin: [0,2,0,0] }], width: '*' },
              { stack: [{ text: 'ESTADO', fontSize: 6.5, color: '#999', bold: true }, { text: talhao.estado || talhao.propriedade_estado || '-', fontSize: 11, bold: true, color: '#333', margin: [0,2,0,0] }], width: 60 },
              { stack: [{ text: 'LATITUDE', fontSize: 6.5, color: '#999', bold: true }, { text: talhao.coordenada_y ? Number(talhao.coordenada_y).toFixed(5) + '°' : '-', fontSize: 9, bold: true, color: '#333', margin: [0,2,0,0] }], width: 80 },
              { stack: [{ text: 'LONGITUDE', fontSize: 6.5, color: '#999', bold: true }, { text: talhao.coordenada_x ? Number(talhao.coordenada_x).toFixed(5) + '°' : '-', fontSize: 9, bold: true, color: '#333', margin: [0,2,0,0] }], width: 80 },
            ],
            columnGap: 12,
            margin: [0, 0, 0, 6]
          },

          // ─ Histórico de Eventos ─
          ...(eventoRows.length ? [
            { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 535, y2: 0, lineWidth: 0.5, lineColor: '#e8e8e8' }], margin: [0, 4, 0, 6] },
            sectionTitle('HISTÓRICO DE EVENTOS RECENTES', '#ef6c00'),
            {
              table: {
                widths: [60, 80, '*'],
                body: [
                  [
                    { text: 'DATA', fontSize: 7, bold: true, color: '#999', border: [false,false,false,true], borderColor: ['','','','#ccc'], fillColor: '#f7f7f7' },
                    { text: 'TIPO', fontSize: 7, bold: true, color: '#999', border: [false,false,false,true], borderColor: ['','','','#ccc'], fillColor: '#f7f7f7' },
                    { text: 'DESCRIÇÃO', fontSize: 7, bold: true, color: '#999', border: [false,false,false,true], borderColor: ['','','','#ccc'], fillColor: '#f7f7f7' },
                  ],
                  ...eventoRows
                ]
              },
              layout: { hLineWidth: (i, node) => (i === 0 || i === node.table.body.length) ? 0 : 0.4, vLineWidth: () => 0, hLineColor: () => '#eee', paddingLeft: () => 4, paddingRight: () => 4, paddingTop: () => 3, paddingBottom: () => 3 },
              margin: [0, 0, 0, 6]
            }
          ] : []),

          // ─ Custos da Lavoura ─
          ...(eventosComCusto.length > 0 ? [
            { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 535, y2: 0, lineWidth: 0.5, lineColor: '#e8e8e8' }], margin: [0, 4, 0, 6] },
            sectionTitle('CUSTOS DA LAVOURA', '#f57f17'),
            // Cards resumo
            {
              columns: [
                { stack: [{ text: 'TOTAL DE CUSTOS', fontSize: 6.5, color: '#999', bold: true }, { text: fmtBRL(totalCustos), fontSize: 13, bold: true, color: '#e65100', margin: [0,2,0,0] }], width: '*' },
                ...(custoPorHa ? [{ stack: [{ text: 'CUSTO / HECTARE', fontSize: 6.5, color: '#999', bold: true }, { text: fmtBRL(custoPorHa) + '/ha', fontSize: 13, bold: true, color: '#bf360c', margin: [0,2,0,0] }], width: '*' }] : []),
                { stack: [{ text: 'EVENTOS COM CUSTO', fontSize: 6.5, color: '#999', bold: true }, { text: String(eventosComCusto.length), fontSize: 13, bold: true, color: '#555', margin: [0,2,0,0] }], width: 100 },
              ],
              columnGap: 12,
              margin: [0, 0, 0, 8]
            },
            // Por tipo de evento
            ...(Object.keys(custosPorTipo).length > 1 ? [{
              table: {
                widths: ['*', 80, 60],
                body: [
                  [
                    { text: 'TIPO DE EVENTO', fontSize: 7, bold: true, color: '#fff', fillColor: '#f57f17', border: [false,false,false,false], margin: [4,3,4,3] },
                    { text: 'CUSTO TOTAL', fontSize: 7, bold: true, color: '#fff', fillColor: '#f57f17', alignment: 'right', border: [false,false,false,false], margin: [4,3,4,3] },
                    { text: '% DO TOTAL', fontSize: 7, bold: true, color: '#fff', fillColor: '#f57f17', alignment: 'center', border: [false,false,false,false], margin: [4,3,4,3] },
                  ],
                  ...Object.entries(custosPorTipo)
                    .sort((a, b) => b[1] - a[1])
                    .map(([tipo, valor], i) => [
                      { text: TIPO_LABELS_PDF[tipo] || tipo, fontSize: 7, bold: true, fillColor: i % 2 === 0 ? '#fff8f0' : '#fff', border: [false,false,false,true], borderColor: ['','','','#f0e0cc'], margin: [4,3,4,3] },
                      { text: fmtBRL(valor), fontSize: 7, color: '#e65100', alignment: 'right', fillColor: i % 2 === 0 ? '#fff8f0' : '#fff', border: [false,false,false,true], borderColor: ['','','','#f0e0cc'], margin: [4,3,4,3] },
                      { text: `${((valor/totalCustos)*100).toFixed(1)}%`, fontSize: 7, color: '#888', alignment: 'center', fillColor: i % 2 === 0 ? '#fff8f0' : '#fff', border: [false,false,false,true], borderColor: ['','','','#f0e0cc'], margin: [4,3,4,3] },
                    ])
                ]
              },
              layout: { hLineWidth: () => 0, vLineWidth: () => 0, paddingLeft: () => 0, paddingRight: () => 0, paddingTop: () => 0, paddingBottom: () => 0 },
              margin: [0, 0, 0, 8]
            }] : []),
            // Detalhamento por evento
            {
              table: {
                widths: [52, 68, '*', 68],
                body: [
                  [
                    { text: 'DATA', fontSize: 7, bold: true, color: '#fff', fillColor: '#795548', border: [false,false,false,false], margin: [4,3,4,3] },
                    { text: 'TIPO', fontSize: 7, bold: true, color: '#fff', fillColor: '#795548', border: [false,false,false,false], margin: [4,3,4,3] },
                    { text: 'DESCRIÇÃO', fontSize: 7, bold: true, color: '#fff', fillColor: '#795548', border: [false,false,false,false], margin: [4,3,4,3] },
                    { text: 'CUSTO', fontSize: 7, bold: true, color: '#fff', fillColor: '#795548', alignment: 'right', border: [false,false,false,false], margin: [4,3,4,3] },
                  ],
                  ...eventosComCusto.map((ev, i) => {
                    const bg = i % 2 === 0 ? '#fff8f0' : '#fff';
                    const border = [false,false,false,true];
                    const borderColor = ['','','','#f0e0cc'];
                    const dataFmt = ev.data_evento ? new Date(ev.data_evento).toLocaleDateString('pt-BR') : '-';
                    const detalhes = ev.custo_detalhes
                      ? Object.entries(ev.custo_detalhes).filter(([,v]) => v && Number(v) > 0)
                          .map(([k,v]) => `${CUSTO_LABELS_PDF[k]||k}: ${fmtBRL(v)}`).join(' · ')
                      : '';
                    return [
                      { text: dataFmt, fontSize: 6.5, fillColor: bg, border, borderColor, margin: [4,3,4,3] },
                      { text: TIPO_LABELS_PDF[ev.tipo] || ev.tipo || '-', fontSize: 6.5, bold: true, fillColor: bg, border, borderColor, margin: [4,3,4,3] },
                      { stack: [
                          { text: ev.titulo || '-', fontSize: 6.5, fillColor: bg },
                          ...(detalhes ? [{ text: detalhes, fontSize: 5.5, color: '#888', italics: true, margin: [0,1,0,0] }] : [])
                        ], fillColor: bg, border, borderColor, margin: [4,3,4,3] },
                      { text: fmtBRL(ev.custo_total), fontSize: 7, bold: true, color: '#e65100', alignment: 'right', fillColor: bg, border, borderColor, margin: [4,3,4,3] },
                    ];
                  }),
                  // Linha totalizadora
                  [
                    { text: 'TOTAL', colSpan: 3, fontSize: 7, bold: true, color: '#fff', fillColor: '#795548', border: [false,false,false,false], margin: [4,3,4,3] }, {}, {},
                    { text: fmtBRL(totalCustos), fontSize: 7, bold: true, color: '#fff', fillColor: '#795548', alignment: 'right', border: [false,false,false,false], margin: [4,3,4,3] },
                  ]
                ]
              },
              layout: { hLineWidth: () => 0, vLineWidth: () => 0, paddingLeft: () => 0, paddingRight: () => 0, paddingTop: () => 0, paddingBottom: () => 0 },
              margin: [0, 0, 0, 6]
            },
          ] : []),

          // ─ Zoneamento e Aptidão Agrícola ─
          ...((dadosZARC || koppenLabel || etoProjeto) ? [
            { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 535, y2: 0, lineWidth: 0.5, lineColor: '#e8e8e8' }], margin: [0, 4, 0, 6] },
            sectionTitle('ZONEAMENTO E APTIDÃO AGRÍCOLA', '#2e7d32'),

            // Köppen + ETo lado a lado
            ...((koppenLabel || etoProjeto) ? [{
              columns: [
                ...(koppenLabel ? [{
                  stack: [
                    { text: 'CLIMA (KÖPPEN)', fontSize: 6.5, color: '#999', bold: true },
                    { text: koppenLabel, fontSize: 9, bold: true, color: '#1565c0', margin: [0, 2, 0, 0] }
                  ],
                  width: '*'
                }] : []),
                ...(etoProjeto ? [{
                  stack: [
                    { text: 'ETo DE PROJETO (80% prob.)', fontSize: 6.5, color: '#999', bold: true },
                    { text: `${etoProjeto} mm/dia`, fontSize: 13, bold: true, color: '#1976d2', margin: [0, 2, 0, 0] },
                    { text: 'Ref. para dimensionamento de irrigação', fontSize: 6, color: '#aaa', italics: true }
                  ],
                  width: 140
                }] : [])
              ],
              columnGap: 12,
              margin: [0, 0, 0, 8]
            }] : []),

            // ZARC
            ...(dadosZARC ? [
              // Melhor período em destaque
              ...(dadosZARC.melhorPeriodo ? [{
                columns: [
                  {
                    stack: [
                      { text: 'MELHOR PERÍODO DE PLANTIO (ZARC)', fontSize: 6.5, color: '#999', bold: true },
                      { text: dadosZARC.melhorPeriodo.descricao, fontSize: 13, bold: true, color: '#2e7d32', margin: [0, 2, 0, 0] },
                      { text: `Decêndio ${dadosZARC.melhorDecendio} • Risco mínimo: ${dadosZARC.melhorRisco}`, fontSize: 7, color: '#555' }
                    ],
                    width: '*'
                  },
                  {
                    stack: [
                      { text: 'DECÊNDIOS IDEAIS', fontSize: 6.5, color: '#999', bold: true },
                      { text: String(dadosZARC.totalIdeais), fontSize: 20, bold: true, color: '#2e7d32', margin: [0, 1, 0, 0] },
                      { text: 'de 36 decêndios no ano', fontSize: 6.5, color: '#555' }
                    ],
                    width: 80,
                    alignment: 'center'
                  },
                  {
                    stack: [
                      { text: 'ADEQUADOS', fontSize: 6.5, color: '#999', bold: true },
                      { text: String(dadosZARC.totalAdequados), fontSize: 20, bold: true, color: '#f57c00', margin: [0, 1, 0, 0] },
                      { text: 'de 36 decêndios no ano', fontSize: 6.5, color: '#555' }
                    ],
                    width: 80,
                    alignment: 'center'
                  }
                ],
                columnGap: 12,
                margin: [0, 0, 0, 6]
              }] : []),
              // Períodos ideais / adequados
              ...((dadosZARC.mesesIdeais || dadosZARC.mesesAdequados) ? [{
                table: {
                  widths: [80, '*'],
                  body: [
                    ...(dadosZARC.mesesIdeais ? [[
                      { text: 'Períodos ideais', fontSize: 7, bold: true, color: '#2e7d32', border: [false,false,false,true], borderColor: ['','','','#e8e8e8'], margin: [2,3,2,3] },
                      { text: dadosZARC.mesesIdeais, fontSize: 7, color: '#2e7d32', border: [false,false,false,true], borderColor: ['','','','#e8e8e8'], margin: [2,3,2,3] }
                    ]] : []),
                    ...(dadosZARC.mesesAdequados ? [[
                      { text: 'Períodos adequados', fontSize: 7, bold: true, color: '#f57c00', border: [false,false,false,false], margin: [2,3,2,3] },
                      { text: dadosZARC.mesesAdequados, fontSize: 7, color: '#f57c00', border: [false,false,false,false], margin: [2,3,2,3] }
                    ]] : [])
                  ]
                },
                layout: { hLineWidth: () => 0, vLineWidth: () => 0, paddingLeft: () => 0, paddingRight: () => 0, paddingTop: () => 0, paddingBottom: () => 0 },
                margin: [0, 0, 0, 4]
              }] : []),
              // Comparação plantio real vs ZARC
              ...(talhao.data_plantio && dadosZARC.melhorPeriodo ? [{
                stack: [{
                  text: `Plantio realizado em ${fmtData(talhao.data_plantio)} — compare com o período recomendado pelo ZARC.`,
                  fontSize: 7, italics: true, color: '#666', margin: [0, 2, 0, 0]
                }],
                margin: [0, 0, 0, 4]
              }] : [])
            ] : [
              { text: 'Dados ZARC não disponíveis para esta cultura/município.', fontSize: 8, color: '#888', italics: true }
            ])
          ] : []),
        ],

        footer: (currentPage, pageCount) => ({
          columns: [
            { text: `Página ${currentPage} de ${pageCount}`, fontSize: 7, color: '#aaa', margin: [28, 8, 0, 0] },
            { text: `ClimoraX • ${new Date().toLocaleDateString('pt-BR')}`, fontSize: 7, color: '#1976d2', bold: true, alignment: 'right', margin: [0, 8, 28, 0] }
          ]
        })
      };

      const nomeArq = `relatorio_${(talhao.nome || 'talhao').replace(/[^a-zA-Z0-9_-]/g, '_')}_${localDateStr()}.pdf`;

      let isCapacitor = false;
      try {
        isCapacitor = typeof window !== 'undefined' && window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform();
      } catch (e) { isCapacitor = false; }

      if (isCapacitor && Filesystem && Directory) {
        pdfMake.createPdf(docDefinition).getBase64(async (pdfBase64) => {
          try {
            const result = await Filesystem.writeFile({
              path: nomeArq,
              data: pdfBase64,
              directory: Directory.Documents,
            });
            if (FileOpener && result.uri) {
              try {
                await FileOpener.open({ filePath: result.uri, contentType: 'application/pdf' });
                alert(`Relatório salvo com sucesso!\n\nArquivo: ${nomeArq}\n\nSe não abrir automaticamente, procure na pasta Documentos do seu gerenciador de arquivos.`);
              } catch (openErr) {
                alert(`PDF salvo com sucesso!\n\nArquivo: ${nomeArq}\n\nProcure na pasta "Documentos" do seu gerenciador de arquivos.\n\nCaminho: ${result.uri}`);
              }
            } else {
              alert(`PDF salvo com sucesso!\n\nArquivo: ${nomeArq}\n\nProcure na pasta "Documentos" do seu gerenciador de arquivos.`);
            }
          } catch (err) {
            alert('Erro ao salvar PDF no dispositivo: ' + (err && err.message ? err.message : JSON.stringify(err)));
          } finally {
            setGerandoRelatorio(false);
          }
        }, (err) => {
          alert('Erro ao gerar PDF: ' + (err && err.message ? err.message : JSON.stringify(err)));
          setGerandoRelatorio(false);
        });
        return; // Não chama o finally abaixo — o callback cuida disso
      } else {
        pdfMake.createPdf(docDefinition).download(nomeArq);
      }
    } catch (err) {
      console.error('Erro ao gerar relatório:', err);
    } finally {
      setGerandoRelatorio(false);
    }
  };

  useEffect(() => {
    async function fetchPrevisao() {
      if (subAba !== 'previsao' || !talhao?.coordenada_x || !talhao?.coordenada_y) return;
      setLoadingPrevisao(true);
      // Consulta ao Supabase: busca o registro mais próximo das coordenadas do talhão
      const { data, error } = await supabase
        .rpc('nearest_weekly_gfs_forecast', {
          x: talhao.coordenada_x,
          y: talhao.coordenada_y
        });
      if (error) {
        setPrevisao({ error: 'Erro ao buscar previsão: ' + error.message });
      } else {
        setPrevisao(data?.[0] || null);
      }
      setLoadingPrevisao(false);
    }
    fetchPrevisao();
  }, [subAba, talhao]);

  if (!talhao) return null;

  return (
    <div
      className={`props-detail-shell ${darkMode ? 'is-dark' : ''}`}
      style={{
        maxWidth: isLargeScreen ? 900 : '100%',
        margin: '0 auto',
        background: darkMode ? '#1a1a2e' : '#f7fafd',
        borderRadius: isLargeScreen ? 16 : 0,
        boxShadow: isLargeScreen ? (darkMode ? '0 2px 8px #0006' : '0 2px 16px #0001') : 'none',
        padding: isLargeScreen ? 24 : '12px 12px 80px 12px',
        paddingTop: isLargeScreen ? 'calc(env(safe-area-inset-top, 0px) + 24px)' : 'calc(env(safe-area-inset-top, 0px) + 12px)',
        paddingLeft: 'calc(env(safe-area-inset-left, 0px) + ' + (isLargeScreen ? '24px' : '12px') + ')',
        paddingRight: 'calc(env(safe-area-inset-right, 0px) + ' + (isLargeScreen ? '24px' : '12px') + ')',
        fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
        boxSizing: 'border-box',
        width: '100%',
        minHeight: '100vh'
      }}
    >
      {/* Barra de ferramentas desktop */}
      {isDesktop && (
        <div style={{
          display: 'flex',
          gap: 8,
          marginBottom: 12,
          padding: '8px 12px',
          background: darkMode ? '#1e2a3a' : '#e3f2fd',
          borderRadius: 8,
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <div style={{ display: 'flex', gap: 8 }}>
            <button
              onClick={exportarPDF}
              style={{
                background: podeUsarPdf ? '#d32f2f' : '#ff9800',
                color: '#fff',
                border: 'none',
                borderRadius: 6,
                padding: '6px 12px',
                fontSize: 13,
                fontWeight: 600,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: 6
              }}
              title={podeUsarPdf ? "Exportar PDF (Ctrl+P)" : "PDF (Premium)"}
            >
              <FaFilePdf /> {podeUsarPdf ? 'PDF' : '🔒 PDF'}
            </button>
          </div>
          <button
            onClick={() => setMostrarAtalhos(!mostrarAtalhos)}
            style={{
              background: 'transparent',
              color: '#1976d2',
              border: '1px solid #1976d2',
              borderRadius: 6,
              padding: '6px 12px',
              fontSize: 12,
              fontWeight: 600,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: 6
            }}
            title="Atalhos (Ctrl+H)"
          >
            <FaKeyboard /> Atalhos
          </button>
        </div>
      )}
      
      {/* Modal de atalhos */}
      {mostrarAtalhos && isDesktop && (
        <div style={{
          background: darkMode ? '#232526' : '#fff',
          border: `2px solid ${darkMode ? '#444' : '#1976d2'}`,
          borderRadius: 12,
          padding: 16,
          marginBottom: 16,
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
        }}>
          <h4 style={{ margin: '0 0 12px 0', color: darkMode ? '#90caf9' : '#1976d2' }}>⌨️ Atalhos de Teclado</h4>
          <div style={{ fontSize: 13, lineHeight: 1.8, color: darkMode ? '#e0e0e0' : undefined }}>
            <div><kbd style={{ background: darkMode ? '#333' : '#f5f5f5', padding: '2px 6px', borderRadius: 4 }}>Ctrl+1</kbd> → Fenologia</div>
            <div><kbd style={{ background: darkMode ? '#333' : '#f5f5f5', padding: '2px 6px', borderRadius: 4 }}>Ctrl+2</kbd> → Clima do Talhão</div>
            <div><kbd style={{ background: darkMode ? '#333' : '#f5f5f5', padding: '2px 6px', borderRadius: 4 }}>Ctrl+3</kbd> → Previsão</div>
            <div><kbd style={{ background: darkMode ? '#333' : '#f5f5f5', padding: '2px 6px', borderRadius: 4 }}>Ctrl+4</kbd> → Fotos</div>
            <div><kbd style={{ background: darkMode ? '#333' : '#f5f5f5', padding: '2px 6px', borderRadius: 4 }}>Ctrl+5</kbd> → Informações</div>
            <div><kbd style={{ background: darkMode ? '#333' : '#f5f5f5', padding: '2px 6px', borderRadius: 4 }}>Ctrl+P</kbd> → Exportar PDF</div>
            <div><kbd style={{ background: darkMode ? '#333' : '#f5f5f5', padding: '2px 6px', borderRadius: 4 }}>Ctrl+H</kbd> → Mostrar/Ocultar Atalhos</div>
          </div>
        </div>
      )}
      
      <button
        className="props-back-button props-back-button-full"
        onClick={onVoltar}
        style={{
          marginBottom: 16,
          border: 'none',
          borderRadius: 8,
          padding: '0.5rem 1.5rem',
          fontWeight: 600,
          cursor: 'pointer',
          width: '100%',
          fontSize: isLargeScreen ? 16 : 14,
          boxShadow: '0 1px 4px #0001',
          boxSizing: 'border-box'
        }}
      >
        {backLabel}
      </button>
      <div style={{ textAlign: 'center', marginBottom: 18 }}>
        <h2 style={{
          color: darkMode ? '#90caf9' : '#1976d2',
          marginBottom: 8,
          fontWeight: 700,
          fontSize: isLargeScreen ? 22 : 18,
          letterSpacing: 0.5,
          wordBreak: 'break-word'
        }}>
          {talhao.nome}
        </h2>
        {permission !== 'owner' && (
          <div style={{
            display: 'inline-block',
            background: permission === 'editor' ? '#2196f3' : '#ff9800',
            color: '#fff',
            padding: '4px 12px',
            borderRadius: 12,
            fontSize: 11,
            fontWeight: 600,
            marginTop: 4
          }}>
            {permission === 'editor' ? '✏️ Editor' : '👁️ Modo Visualização'}
          </div>
        )}
      </div>
      <div className="props-subtabbar" style={{
        display: 'flex',
        gap: isLargeScreen ? 6 : 4,
        marginBottom: 20,
        borderRadius: 10,
        overflow: 'hidden',
        boxShadow: '0 1px 4px #0001',
        flexWrap: isLargeScreen ? 'nowrap' : 'wrap',
        boxSizing: 'border-box'
      }}>
        {/* Aba Planejamento — apenas quando safra planejada */}
        {statusTalhao === 'planejado' && (
          <button
            className={`props-subtab-btn ${subAba === 'planejamento' ? 'is-active' : ''}`}
            style={{
              flex: isLargeScreen ? 1 : '1 1 48%',
              border: 'none',
              padding: isLargeScreen ? '0.7rem 0' : '0.6rem 0.3rem',
              fontWeight: 700,
              fontSize: isLargeScreen ? 16 : 13,
              cursor: 'pointer',
              transition: 'all 0.2s',
              boxSizing: 'border-box',
              minWidth: 0
            }}
            onClick={() => setSubAba('planejamento')}
          >
            🗓️ Planejamento
          </button>
        )}
        {/* Abas de análise — ocultas em safra planejada */}
        {statusTalhao !== 'planejado' && (
          <button
            className={`props-subtab-btn ${subAba === 'fenologia' ? 'is-active' : ''}`}
            style={{
              flex: isLargeScreen ? 1 : '1 1 48%',
              border: 'none',
              padding: isLargeScreen ? '0.7rem 0' : '0.6rem 0.3rem',
              fontWeight: 700,
              fontSize: isLargeScreen ? 16 : 13,
              cursor: 'pointer',
              transition: 'all 0.2s',
              boxSizing: 'border-box',
              minWidth: 0
            }}
            onClick={() => setSubAba('fenologia')}
          >
            🌱 Fenologia
          </button>
        )}
        {statusTalhao !== 'planejado' && (
          <button
            className={`props-subtab-btn ${subAba === 'balanco' ? 'is-active' : ''}`}
            style={{
              flex: isLargeScreen ? 1 : '1 1 48%',
              border: 'none',
              padding: isLargeScreen ? '0.7rem 0' : '0.6rem 0.3rem',
              fontWeight: 700,
              fontSize: isLargeScreen ? 16 : 13,
              cursor: 'pointer',
              transition: 'all 0.2s',
              boxSizing: 'border-box',
              minWidth: 0
            }}
            onClick={() => setSubAba('balanco')}
          >
            🌦️ Clima do Talhão
          </button>
        )}
        {statusTalhao !== 'colhido' && (
          <button
          className={`props-subtab-btn ${subAba === 'previsao' ? 'is-active' : ''}`}
          style={{
            flex: isLargeScreen ? 1 : '1 1 48%',
            border: 'none',
            padding: isLargeScreen ? '0.7rem 0' : '0.6rem 0.3rem',
            fontWeight: 700,
            fontSize: isLargeScreen ? 16 : 13,
            cursor: 'pointer',
            transition: 'all 0.2s',
            boxSizing: 'border-box',
            minWidth: 0
          }}
          onClick={() => setSubAba('previsao')}
        >
          🌦️ Previsão
        </button>
        )}
        <button
            className={`props-subtab-btn ${subAba === 'fotos' ? 'is-active' : ''}`}
            style={{
              flex: isLargeScreen ? 1 : '1 1 48%',
              border: 'none',
              padding: isLargeScreen ? '0.7rem 0' : '0.6rem 0.3rem',
              fontWeight: 700,
              fontSize: isLargeScreen ? 16 : 13,
              cursor: 'pointer',
              transition: 'all 0.2s',
              boxSizing: 'border-box',
              minWidth: 0
            }}
            onClick={() => setSubAba('fotos')}
          >
            📷 Fotos
          </button>
        <button
          className={`props-subtab-btn ${subAba === 'info' ? 'is-active' : ''}`}
          style={{
            flex: isLargeScreen ? 1 : '1 1 48%',
            border: 'none',
            padding: isLargeScreen ? '0.7rem 0' : '0.6rem 0.3rem',
            fontWeight: 700,
            fontSize: isLargeScreen ? 16 : 13,
            cursor: 'pointer',
            transition: 'all 0.2s',
            boxSizing: 'border-box',
            minWidth: 0
          }}
          onClick={() => setSubAba('info')}
        >
          📊 Info
        </button>
      </div>

      {/* Botão Gerar Relatório Completo — oculto em safra planejada */}
      {statusTalhao !== 'planejado' && <button
        onClick={exportarRelatorioTalhao}
        disabled={gerandoRelatorio}
        style={{
          width: '100%',
          background: gerandoRelatorio ? '#90a4ae' : podeUsarPdf ? 'linear-gradient(135deg, #1565c0, #0d47a1)' : 'linear-gradient(135deg, #f59e0b, #d97706)',
          color: '#fff',
          border: 'none',
          borderRadius: 8,
          padding: '10px 0',
          fontSize: 14,
          fontWeight: 700,
          cursor: gerandoRelatorio ? 'not-allowed' : 'pointer',
          marginBottom: 10,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 8,
          boxShadow: gerandoRelatorio ? 'none' : '0 2px 8px #0d47a144',
          transition: 'all 0.2s',
          boxSizing: 'border-box'
        }}
      >
        {gerandoRelatorio ? '⏳ Gerando relatório...' : podeUsarPdf ? '📋 Gerar Relatório Completo do Talhão' : '🔒 Relatório Completo (Premium)'}
      </button>}

      <div className="props-subtab-panel" style={{
        background: darkMode ? '#232526' : '#fff',
        borderRadius: 12,
        boxShadow: darkMode ? '0 2px 8px #0006' : '0 1px 4px #0001',
        padding: isLargeScreen ? 12 : 8,
        marginBottom: 12,
        minHeight: 180,
        boxSizing: 'border-box',
        width: '100%',
        overflowX: 'hidden'
      }}>
        {subAba === 'planejamento' && (
          <PlanejamentoSafra
            talhao={talhao}
            podeEditar={podeEditar}
          />
        )}
        {subAba === 'fenologia' && (
          <>
            {/* Novo componente dinâmico, usando cultura e data de plantio */}
            <FenologiaNova cultura={talhao.cultura} dataPlantio={talhao.data_plantio} dataColheita={talhao.data_colheita} talhaoId={talhao.id} permission={permission} />
            {/* Componente antigo mantido para comparação visual */}
            {/* <Fenologia dataPlantio={talhao.data_plantio} dataColheita={talhao.data_colheita} /> */}
          </>
        )}
        {subAba === 'balanco' && <BalancoHidrico talhao={talhao} permission={permission} />}
        {subAba === 'previsao' && <PrevisaoSemanalTalhao previsao={previsao} loading={loadingPrevisao} />}
        {subAba === 'fotos' && <AlbumFotos talhao={talhao} user={user} permission={permission} />}
        {subAba === 'info' && <InfoAdicionais talhao={talhao} />}
        {/* Botão de exportação de PDF na aba de fotos */}
      </div>
      
      {/* Modal de upgrade para recursos Premium */}
      <UpgradeModal 
        isOpen={showUpgradeModal}
        onClose={() => setShowUpgradeModal(false)}
        show={showUpgradeModal}
        recurso="relatorios"
        usuario={user}
      />
    </div>
  );
}
